// The Masteek gallery and shop: generated from the static site by build_theme.py, loaded by sections/masteek-catalog.liquid.

(() => {
  if (customElements.get('masteek-native-catalog')) return;
  class MasteekNativeCatalog extends HTMLElement {
    connectedCallback() {
      if (this.catalogMounted) return;
      this.catalogMounted = true;
      const root = this;
      const {assets:assetData, live:liveData, currency:liveCurrency, initialProduct, i18n} = JSON.parse(root.querySelector('[data-masteek-config]').textContent);
      const asset = path => assetData[path] || path;
      const runtime = {};
      this.eventController = new AbortController();
      const eventSignal = this.eventController.signal;
      const eventOptions = options => typeof options === 'boolean' ? {capture:options, signal:eventSignal} : {...options, signal:eventSignal};
      this.observers = [];
      this.timers = new Set();
      this.frames = new Set();
      const requestAnimationFrame = callback => {
        const id = window.requestAnimationFrame(time => {root.frames.delete(id); if(root.isConnected) callback(time);});
        root.frames.add(id); return id;
      };
      const cancelAnimationFrame = id => {window.cancelAnimationFrame(id); root.frames.delete(id);};
      const setTimeout = (callback, delay) => {
        const id = window.setTimeout(() => {root.timers.delete(id); if(root.isConnected) callback();}, delay);
        root.timers.add(id); return id;
      };
      const clearTimeout = id => {window.clearTimeout(id); root.timers.delete(id);};
      const ResizeObserver = class extends window.ResizeObserver {
        constructor(callback) {super(callback); root.observers.push(this);}
      };
      const MutationObserver = class extends window.MutationObserver {
        constructor(callback) {super(callback); root.observers.push(this);}
      };
      const IntersectionObserver = window.IntersectionObserver && class extends window.IntersectionObserver {
        constructor(callback, options) {super(callback, options); root.observers.push(this);}
      };
      const dom = {
        getElementById: id => root.querySelector('[id="' + id + '"]'),
        querySelectorAll: selector => root.querySelectorAll(selector),
        querySelector: selector => root.querySelector(selector),
        createElement: tag => document.createElement(tag),
        createTextNode: text => document.createTextNode(text),
        body: document.body,
        get activeElement() {return document.activeElement;},
        get title() {return document.title;},
        set title(value) {document.title = value;},
        addEventListener: (type, handler, options = {}) => document.addEventListener(type, handler, {...options, signal:root.eventController.signal})
      };
// ---- pieces.js
// Photo numbers and tentative character matches are documented in review/aot-photos.json.
(() => {
  // Each photo comes in two sizes: full for the closer look, and a 648 px wide copy for the slideshow and the piece cards.
  const photo = (number, size) => asset('assets/aot/' + String(number).padStart(2, '0') + (size === 'small' ? '-648' : '') + '.webp');
  runtime.PIECES = [
    {id:'armored',name:'Armored Titan',role:'Rook',team:'humans',photo:24,quantity:1,description:"Schrödinger's Titan: can't die, can't win"},
    {id:'jean',name:'Jean',role:'Knight',team:'humans',photo:28,quantity:1,description:"Humanity's bravest horse"},
    {id:'levi',name:'Levi',role:'Bishop',team:'humans',photo:27,quantity:1,description:'The reason Zeke checks under his bed'},
    {id:'historia',name:'Historia',role:'Queen',team:'humans',photo:29,quantity:1,description:'Made history, then went back to the farm'},
    {id:'erwin',name:'Armin Colossal Titan',role:'King',team:'humans',photo:26,quantity:1,description:'“I come in peace.” Proceeds to vaporize the harbor'},
    {id:'mikasa',name:'Mikasa',role:'Bishop',team:'humans',photo:25,quantity:1,description:'Ereh 💔'},
    {id:'armin',name:'Erwin',role:'Knight',team:'humans',placeholder:true,quantity:1,description:'Morale: 100%. Survival rate: 0%'},
    {id:'colossal',name:'Female Titan',role:'Rook',team:'humans',placeholder:true,quantity:1,description:'Relationship status: crystallized'},
    {id:'reiner',name:'Eren',role:'Pawn',team:'humans',photo:18,quantity:1,description:'Most likely to turn a group project into a genocide'},
    {id:'sasha',name:'Sasha',role:'Pawn',team:'humans',photo:20,quantity:1,description:'"Bread"'},
    {id:'connie',name:'Connie',role:'Pawn',team:'humans',photo:17,quantity:1,description:"“At least Mom's still home.”"},
    {id:'eren',name:'Floch',role:'Pawn',team:'humans',photo:16,quantity:1,description:"CEO of Eren's fan club"},
    {id:'bertholdt',name:'Gabi',role:'Pawn',team:'humans',photo:23,quantity:1,description:'One shot, millions of haters'},
    {id:'ymir',name:'Petra',role:'Pawn',team:'humans',photo:19,quantity:1,description:'Left the wedding plans unfinished'},
    {id:'hange',name:'Hange',role:'Pawn',team:'humans',photo:22,quantity:1,description:"“It's not a monster. It's a research opportunity.”"},
    {id:'pixis',name:'Pixis',role:'Pawn',team:'humans',photo:21,quantity:1,description:'The Ethanol Titan.'},
    {id:'beast',name:'Beast Titan',role:'Rook',team:'titans',photo:14,quantity:1,description:'Biggest fear - Levi'},
    {id:'jaw',name:'Okapi Titan',role:'Knight',team:'titans',photo:13,quantity:1,description:'“What the hell is an okapi?”'},
    {id:'warhammer',name:'War Hammer Titan',role:'Bishop',team:'titans',placeholder:true,quantity:1},
    {id:'attack',name:'Ymir Founding Titan',role:'Queen',team:'titans',photo:11,quantity:1,description:'Employee of the millennium'},
    {id:'founding',name:'Eren Founding Titan',role:'King',team:'titans',photo:10,quantity:1,description:'Logged off 80% of the world'},
    {id:'warhammer-2',name:'War Hammer Titan',role:'Bishop',team:'titans',placeholder:true,quantity:1},
    {id:'female',name:'Cart Titan',role:'Knight',team:'titans',photo:9,quantity:1,description:'Two Months on All Fours'},
    {id:'cart',name:'Wall Titan',role:'Rook',team:'titans',photo:8,quantity:1,description:'Bricked for 100 years'},
    {id:'smiling',name:'Smiling Titan',role:'Pawn',team:'titans',photo:1,quantity:1,description:'Family reunion gone wrong'},
    {id:'colossal-pawn-2',name:'Colossal Titan',role:'Pawn',team:'titans',photo:3,quantity:1,description:'The biggest introvert in the room'},
    {id:'colossal-pawn',name:'Rumbling Titan',role:'Pawn',team:'titans',photo:2,quantity:1,description:'100 years AFK, then straight into ranked'},
    {id:'colossal-pawn-3',name:'Rumbling Titan',role:'Pawn',team:'titans',photo:4,quantity:1,description:'100 years AFK, then straight into ranked'},
    {id:'colossal-pawn-4',name:'Rumbling Titan',role:'Pawn',team:'titans',photo:5,quantity:1,description:'100 years AFK, then straight into ranked'},
    {id:'colossal-pawn-5',name:'Rumbling Titan',role:'Pawn',team:'titans',photo:6,quantity:1,description:'100 years AFK, then straight into ranked'},
    {id:'colossal-pawn-6',name:'Rumbling Titan',role:'Pawn',team:'titans',photo:7,quantity:1,description:'100 years AFK, then straight into ranked'},
    {id:'pure',name:'Rumbling Titan',role:'Pawn',team:'titans',photo:15,quantity:1,description:'100 years AFK, then straight into ranked'}
  ].map(piece => {
    const images = piece.placeholder ? [asset('assets/question-mark.svg')] : (piece.photos || [piece.photo]).map(number => photo(number));
    const image = piece.placeholder ? images[0] : photo((piece.photos || [piece.photo])[0], 'small');
    return {...piece, image, images, placeholder:!!piece.placeholder, transparent:true, aspect:.75};
  });
})();

// ---- products.js
// Prices and availability refresh from Masteek; the values here are the fallback.
// Modern product photos and specifications: masteek.com/products/modern-led-chess-set, verified 2026-10-16.
// Original product photos and specifications: masteek.com/products/original-led-chess-set, verified 2026-10-16.
// "page" gives a set the full product page; its fields fill the parts of that page that differ between sets.
// "heights" are each piece's height in cm, base included; every base is 2.2 cm wide in both sets. A set without them
// (AOT, still being measured) skips the to-scale lineup.
// "backed": false marks a set that was not on Kickstarter (AOT): its page leaves out the backer quotes and mentions.
// "preorder" is when a pre-order set ships ("November 12"); it replaces the in-stock wording across its page.
// "edition" is how many sets will ever be made; the buy box counts down what is left of it under the availability line.
// "note" is a line under the buy box's availability, for anything a buyer should know before ordering.
// "characterGallery" adds a buy box link down to the AOT character gallery on the set's page.
// "addOns" are another set's 32 pieces (no board) at +€100, sold only together with this set: each is a Shopify bundle
// of this set and a hidden pieces-only product, priced as the sum of the two. Buyers pick one. An add-on marked
// "comingSoon" is listed but cannot be picked.
// "setCutout" is the pieces picture of the set-alone option, the same size as the add-ons' pieces (AOT's trio is Jean,
// Mikasa and the Smiling Titan); that option also shows the board under its cover where the add-ons show their price.
// "box" pictures fill What you get; "cutout": true marks a transparent cut-out (the board and cover) shown whole.
// "aliases" are retired addresses that now open the set in the Catalog (the old Full set page, #full-set and #rinkinys).
// AOT set photos (assets/aot-product) are Masteek's own, 2026-10-17, cropped to 16:9.
// Original piece cut-outs (assets/original) come from Masteek's own close-up photos, 2026-10-16; the lineup photos
// (assets/original-lineup) are cropped from them, under a new path so browsers drop the earlier lineup photos.
runtime.MASTEEK_PRODUCTS = [
  {
    "id": "aot",
    "name": i18n["AOT"],
    "subtitle": i18n["Attack on Titan inspired chess set"],
    "description": i18n["32 character pieces, Humanity versus Titans. They glow as they near the board, powered wirelessly, with no batteries."],
    "image": asset("assets/aot-product/09.webp"),
    "offImage": asset("assets/aot-product/08.webp"),
    "handle": "aot-inspired-chess-set",
    "aliases": ["#full-set", "#rinkinys"],
    "price": 299.0,
    "comparePrice": 399.0,
    "available": true,
    "preorder": "November 12",
    "edition": 30,
    "url": "https://masteek.com/products/aot-inspired-chess-set",
    "checkoutUrl": "https://masteek.com/cart/58605805371740:1",
    "setCutout": asset("assets/aot-pieces-trio.webp"),
    "addOns": [
      {"pieces": "modern", "price": 100.0, "image": asset("assets/modern-pieces-trio.webp"), "handle": "aot-inspired-chess-set-with-modern-pieces", "available": true, "checkoutUrl": "https://masteek.com/cart/59535823667548:1"},
      {"pieces": "original", "price": 100.0, "image": asset("assets/original-pieces-trio.webp"), "handle": "aot-inspired-chess-set-with-original-pieces", "available": true, "checkoutUrl": "https://masteek.com/cart/59535823798620:1"}
    ],
    "photos": [
      {"src":asset("assets/aot-product/09.webp"),"light":"on","alt":i18n["The Eren piece glowing on the board, the Humanity pieces behind him"]},
      {"src":asset("assets/aot-product/01.webp"),"light":"on","alt":i18n["The AOT set lit up under its acrylic cover, Titans in red and Humanity in white"]},
      {"src":asset("assets/aot-product/10.webp"),"light":"on","alt":i18n["The red Colossal Titan piece glowing, its bare muscles and teeth lit from the board"]},
      {"src":asset("assets/aot-product/02.webp"),"light":"on","alt":i18n["AOT pieces glowing red and white inside the acrylic display cover"]},
      {"src":asset("assets/aot-product/03.webp"),"light":"on","alt":i18n["Red Titans facing white Humanity across the AOT board"]},
      {"src":asset("assets/aot-product/04.webp"),"light":"on","alt":i18n["Close-up of the red Titan pieces lit from the board"]},
      {"src":asset("assets/aot-product/05.webp"),"light":"on","alt":i18n["Close-up of the white Humanity pieces lit from the board"]},
      {"src":asset("assets/aot-product/06.webp"),"light":"on","alt":i18n["A row of Humanity pieces glowing blue on the board"]},
      {"src":asset("assets/aot-product/07.webp"),"light":"on","alt":i18n["Red Titan pieces up close, lit from their bases"]},
      {"src":asset("assets/aot-product/08.webp"),"light":"off","alt":i18n["The AOT Humanity pieces with the lights off"]}
    ],
    "page": {
      "hash": "#aot-chess-set",
      "backed": false,
      "note": "Four designs are getting their final look. All 32 pieces ship together.",
      "characterGallery": true,
      "box": {
        "board": {"src":asset("assets/aot-product/03.webp"),"alt":i18n["AOT pieces lit up on the acrylic LED board"]},
        "pieces": {"src":asset("assets/aot-product/05.webp"),"alt":i18n["AOT Humanity character pieces up close"],"title":i18n["Character pieces"]},
        "cover": {"src":asset("assets/board-cover.webp"),"alt":i18n["The acrylic LED board under its clear display cover"],"cutout":true}
      },
      "story": {"src":asset("assets/aot-product/02.webp"),"alt":i18n["The AOT set glowing red and white under its acrylic display cover"],"text":i18n["Lights off, the characters stand like a shelf of collectible figures. Lights on, every one of them glows."]}
    }
  },
  {
    "id": "original",
    "name": i18n["Original"],
    "subtitle": i18n["Original LED chess set"],
    "description": i18n["Traditional chess shapes that glow as they near the board, powered wirelessly, with no batteries."],
    "image": asset("assets/original-on.webp"),
    "offImage": asset("assets/original-off.webp"),
    "handle": "original-led-chess-set",
    "price": 299.0,
    "comparePrice": 399.0,
    "available": true,
    "url": "https://masteek.com/products/original-led-chess-set",
    "checkoutUrl": "https://masteek.com/cart/57391468413276:1",
    "setCutout": asset("assets/original-pieces-trio.webp"),
    "addOns": [
      {"pieces": "modern", "price": 100.0, "image": asset("assets/modern-pieces-trio.webp"), "handle": "original-led-chess-set-with-modern-pieces", "available": true, "checkoutUrl": "https://masteek.com/cart/59533913194844:1"}
    ],
    "photos": [
      {"src":asset("assets/original-product/01.webp"),"light":"on","alt":i18n["The Original set glowing white and red under its acrylic display cover"]},
      {"src":asset("assets/original-product/06.webp"),"light":"on","alt":i18n["A white and a red Original knight facing each other on the lit board"]},
      {"src":asset("assets/original-product/02.webp"),"light":"off","alt":i18n["The Original set with its lights off on a wooden side table"]},
      {"src":asset("assets/original-product/03.webp"),"light":"on","alt":i18n["The white Original back row lit up, with a pawn in front"]},
      {"src":asset("assets/original-product/04.webp"),"light":"on","alt":i18n["The red Original back row lit up, with a pawn in front"]},
      {"src":asset("assets/original-product/05.webp"),"light":"on","alt":i18n["White Original pieces lit up on the board, facing the red team"]}
    ],
    "page": {
      "hash": "#original-chess-set",
      "pieceGallery": true,
      "scale": "assets/original-lineup/",
      "heights": {"pawn": 4, "rook": 4, "knight": 4.6, "bishop": 5, "queen": 5.3, "king": 6},
      "box": {
        "board": {"src":asset("assets/original-product/05.webp"),"alt":i18n["White Original pieces lit up on the acrylic board, facing the red team"]},
        "pieces": {"src":asset("assets/original-product/06.webp"),"alt":i18n["A white and a red Original knight facing each other on the lit board"],"title":i18n["Classic pieces"]},
        "cover": {"src":asset("assets/board-cover.webp"),"alt":i18n["The acrylic LED board under its clear display cover"],"cutout":true}
      },
      "story": {"src":asset("assets/original-product/02.webp"),"alt":i18n["The Original set with its lights off on a wooden side table"],"text":i18n["Lights off, the frosted pieces sit quietly on a side table. Lights on, they glow white and red."]}
    }
  },
  {
    "id": "modern",
    "name": i18n["Modern"],
    "subtitle": i18n["Modern LED chess set"],
    "description": i18n["Sculptural pieces that glow as they near the board, powered wirelessly, with no batteries."],
    "image": asset("assets/modern-on.webp"),
    "offImage": asset("assets/modern-off.webp"),
    "handle": "modern-led-chess-set",
    "price": 299.0,
    "comparePrice": 399.0,
    "available": true,
    "url": "https://masteek.com/products/modern-led-chess-set",
    "checkoutUrl": "https://masteek.com/cart/57378470691164:1",
    "setCutout": asset("assets/modern-pieces-trio.webp"),
    "addOns": [
      {"pieces": "original", "price": 100.0, "image": asset("assets/original-pieces-trio.webp"), "handle": "modern-led-chess-set-with-original-pieces", "available": true, "checkoutUrl": "https://masteek.com/cart/59533913162076:1"}
    ],
    "photos": [
      {"src":asset("assets/modern-product/01.webp"),"light":"on","alt":i18n["Illuminated white Modern pieces facing the red team"]},
      {"src":asset("assets/modern-product/02.webp"),"light":"on","alt":i18n["Modern LED chess board with both teams illuminated"]},
      {"src":asset("assets/modern-product/03.webp"),"light":"on","alt":i18n["White and red Modern pieces on the acrylic board"]},
      {"src":asset("assets/modern-product/04.webp"),"light":"on","alt":i18n["Modern chess set with contrasting white and red illumination"]},
      {"src":asset("assets/modern-product/05.webp"),"light":"on","alt":i18n["Two teams of sculptural Modern chess pieces"]},
      {"src":asset("assets/modern-product/06.webp"),"light":"on","alt":i18n["Detail of the illuminated Modern chess set"]},
      {"src":asset("assets/modern-product/07.webp"),"light":"on","alt":i18n["Clear Modern chess pieces on the reflective board"]},
      {"src":asset("assets/modern-product/08.webp"),"light":"on","alt":i18n["Modern pieces glowing through the board"]},
      {"src":asset("assets/modern-product/09.webp"),"light":"on","alt":i18n["Red and white Modern chess pieces against a dark background"]},
      {"src":asset("assets/modern-product/10.webp"),"light":"off","alt":i18n["Modern chess set with lights off and its included acrylic cover"]}
    ],
    "page": {
      "hash": "#modern-chess-set",
      "pieceGallery": true,
      "scale": "assets/modern-scale/",
      "heights": {"pawn": 4, "rook": 4.5, "knight": 4.6, "bishop": 5, "queen": 5, "king": 5.6},
      "box": {
        "board": {"src":asset("assets/modern-product/01.webp"),"alt":i18n["The illuminated acrylic Modern board with pieces in play"]},
        "pieces": {"src":asset("assets/modern-product/03.webp"),"alt":i18n["The six white and six red Modern piece designs side by side"],"title":i18n["Sculptural pieces"]},
        "cover": {"src":asset("assets/board-cover.webp"),"alt":i18n["The acrylic LED board under its clear display cover"],"cutout":true}
      },
      "story": {"src":asset("assets/modern-product/10.webp"),"alt":i18n["Modern chess set displayed with its included acrylic cover"],"text":i18n["Lights off, the sculptural pieces rest under their acrylic cover. Lights on, they glow white and red."]}
    }
  }
];

// ---- live product data (theme only): price, stock, link and checkout variant from Shopify
(() => {
  // Prices below are in the visitor's currency; the price formatter labels them with it.
  if (liveCurrency) runtime.MasteekCurrency = liveCurrency;
  runtime.MASTEEK_PRODUCTS.forEach(p => {
    const live = liveData[p.handle];
    if (!live) return;
    if (!p.priceLocked && Number.isFinite(live.price) && live.price > 0) {
      p.price = live.price;
      p.comparePrice = Number.isFinite(live.compare) && live.compare > live.price ? live.compare : null;
    }
    // A pre-order set stays on sale while Shopify still counts it as out of stock.
    if (typeof live.available === 'boolean') p.available = live.available || Boolean(p.preorder);
    if (live.url) p.url = live.url;
    if (p.page && live.variant) p.checkoutUrl = '/cart/' + live.variant + ':1';
    // Live stock: a limited set counts down, the others say how many are left once only a few are.
    if (Number.isFinite(live.stock)) p.stock = Math.max(0, live.stock);
  });
  // Add-on bundles: an option shows only while its bundle is on sale, so a draft never links to a dead checkout.
  runtime.MASTEEK_PRODUCTS.forEach(p => (p.addOns || []).forEach(addOn => {
    const bundle = liveData[addOn.handle];
    addOn.available = Boolean(bundle && bundle.available);
    if (bundle && Number.isFinite(bundle.price) && bundle.price > p.price) addOn.price = bundle.price - p.price;
    if (bundle && bundle.variant) addOn.checkoutUrl = '/cart/' + bundle.variant + ':1';
  }));
})();

// ---- dialogs.js
(() => {
  let page = null, restoreFrame = 0;
  const dialogs = Array.from(dom.querySelectorAll('dialog'));

  function restorePage() {
    if (!page || dialogs.some(dialog => dialog.open)) return;
    const saved = page;
    page = null;
    dom.body.classList.remove('masteek-dialog-open');
    dom.body.style.removeProperty('--dialog-scroll-top');
    window.scrollTo({left:saved.x, top:saved.y, behavior:'instant'});
    if (saved.focus?.isConnected) saved.focus.focus({preventScroll:true});
    restoreFrame = requestAnimationFrame(() => {
      restoreFrame = 0;
      if (!page) window.scrollTo({left:saved.x, top:saved.y, behavior:'instant'});
    });
  }

  function open(dialog) {
    if (dialog.open) return;
    cancelAnimationFrame(restoreFrame);
    restoreFrame = 0;
    if (!page) {
      page = {x:window.scrollX, y:window.scrollY, focus:dom.activeElement};
      dom.body.style.setProperty('--dialog-scroll-top', -page.y + 'px');
      dom.body.classList.add('masteek-dialog-open');
    }
    try {
      dialog.showModal();
    } catch (error) {
      restorePage();
      throw error;
    }
  }

  dialogs.forEach(dialog => dialog.addEventListener('close', restorePage, {signal:eventSignal}));
  runtime.MasteekDialogs = {open};
})();

// ---- chess-art.js
// The site's chess pieces: the puzzle board, the AOT side picker and the Modern and Original piece galleries all
// draw them from here, so every chess icon looks the same on every device.
(() => {
  // Chess pieces by Colin M.L. Burnett (Cburnett), from Wikimedia Commons, used under the BSD licence:
  // Copyright (c) Colin M.L. Burnett. Redistribution and use in source and binary forms, with or without
  // modification, are permitted provided that redistributions retain this copyright notice, this list of
  // conditions and the following disclaimer. THIS ARTWORK IS PROVIDED "AS IS", WITHOUT ANY WARRANTY.
  // Recoloured for Masteek: White in cream, Black in red, outlines in the board's dark. Drawn on a 45-unit square.
  const ART = {
    wk: '<g fill="none" fill-rule="evenodd" stroke="#191917" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path stroke-linejoin="miter" d="M22.5 11.63V6M20 8h5"/><path fill="#fbf6ea" stroke-linecap="butt" stroke-linejoin="miter" d="M22.5 25s4.5-7.5 3-10.5c0 0-1-2.5-3-2.5s-3 2.5-3 2.5c-1.5 3 3 10.5 3 10.5"/><path fill="#fbf6ea" d="M12.5 37c5.5 3.5 14.5 3.5 20 0v-7s9-4.5 6-10.5c-4-6.5-13.5-3.5-16 4V27v-3.5c-2.5-7.5-12-10.5-16-4-3 6 6 10.5 6 10.5v7"/><path d="M12.5 30c5.5-3 14.5-3 20 0m-20 3.5c5.5-3 14.5-3 20 0m-20 3.5c5.5-3 14.5-3 20 0"/></g>',
    bk: '<g style="fill:none; fill-rule:evenodd; stroke:#191917; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;"><path d="M 22.5,11.63 L 22.5,6" style="fill:none; stroke:#191917; stroke-linejoin:miter;" id="path6570"/><path d="M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25" style="fill:#ff5b45;stroke-linecap:butt; stroke-linejoin:miter;"/><path d="M 12.5,37 C 18,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 20,16 10.5,13 6.5,19.5 C 3.5,25.5 12.5,30 12.5,30 L 12.5,37" style="fill:#ff5b45; stroke:#191917;"/><path d="M 20,8 L 25,8" style="fill:none; stroke:#191917; stroke-linejoin:miter;"/><path d="M 32,29.5 C 32,29.5 40.5,25.5 38.03,19.85 C 34.15,14 25,18 22.5,24.5 L 22.5,26.6 L 22.5,24.5 C 20,18 10.85,14 6.97,19.85 C 4.5,25.5 13,29.5 13,29.5" style="fill:none; stroke:#ffe3dc;"/><path d="M 12.5,30 C 18,27 27,27 32.5,30 M 12.5,33.5 C 18,30.5 27,30.5 32.5,33.5 M 12.5,37 C 18,34 27,34 32.5,37" style="fill:none; stroke:#ffe3dc;"/></g>',
    wq: '<g style="fill:#fbf6ea;stroke:#191917;stroke-width:1.5;stroke-linejoin:round"><path d="M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z"/><path d="M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 11,36 11,36 C 9.5,37.5 11,38.5 11,38.5 C 17.5,39.5 27.5,39.5 34,38.5 C 34,38.5 35.5,37.5 34,36 C 34,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 z"/><path d="M 11.5,30 C 15,29 30,29 33.5,30" style="fill:none"/><path d="M 12,33.5 C 18,32.5 27,32.5 33,33.5" style="fill:none"/><circle cx="6" cy="12" r="2" /><circle cx="14" cy="9" r="2" /><circle cx="22.5" cy="8" r="2" /><circle cx="31" cy="9" r="2" /><circle cx="39" cy="12" r="2" /></g>',
    bq: '<g style="fill:#ff5b45;stroke:#191917;stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round"><path d="M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z" style="stroke-linecap:butt;fill:#ff5b45" /><path d="m 9,26 c 0,2 1.5,2 2.5,4 1,1.5 1,1 0.5,3.5 -1.5,1 -1,2.5 -1,2.5 -1.5,1.5 0,2.5 0,2.5 6.5,1 16.5,1 23,0 0,0 1.5,-1 0,-2.5 0,0 0.5,-1.5 -1,-2.5 -0.5,-2.5 -0.5,-2 0.5,-3.5 1,-2 2.5,-2 2.5,-4 -8.5,-1.5 -18.5,-1.5 -27,0 z" /><path d="M 11.5,30 C 15,29 30,29 33.5,30" /><path d="m 12,33.5 c 6,-1 15,-1 21,0" /><circle cx="6" cy="12" r="2" /><circle cx="14" cy="9" r="2" /><circle cx="22.5" cy="8" r="2" /><circle cx="31" cy="9" r="2" /><circle cx="39" cy="12" r="2" /><path d="M 11,38.5 A 35,35 1 0 0 34,38.5" style="fill:none; stroke:#191917;stroke-linecap:butt;" /><g style="fill:none; stroke:#ffe3dc;"><path d="M 11,29 A 35,35 1 0 1 34,29" /><path d="M 12.5,31.5 L 32.5,31.5" /><path d="M 11.5,34.5 A 35,35 1 0 0 33.5,34.5" /><path d="M 10.5,37.5 A 35,35 1 0 0 34.5,37.5" /></g></g>',
    wr: '<g style="fill:#fbf6ea; fill-rule:evenodd; stroke:#191917; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;" transform="translate(0,0.3)"><path d="M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z " style="stroke-linecap:butt;" /><path d="M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z " style="stroke-linecap:butt;" /><path d="M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14" style="stroke-linecap:butt;" /><path d="M 34,14 L 31,17 L 14,17 L 11,14" /><path d="M 31,17 L 31,29.5 L 14,29.5 L 14,17" style="stroke-linecap:butt; stroke-linejoin:miter;" /><path d="M 31,29.5 L 32.5,32 L 12.5,32 L 14,29.5" /><path d="M 11,14 L 34,14" style="fill:none; stroke:#191917; stroke-linejoin:miter;" /></g>',
    br: '<g style="fill:#ff5b45; fill-rule:evenodd; stroke:#191917; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;" transform="translate(0,0.3)"><path d="M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z " style="stroke-linecap:butt;" /><path d="M 12.5,32 L 14,29.5 L 31,29.5 L 32.5,32 L 12.5,32 z " style="stroke-linecap:butt;" /><path d="M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z " style="stroke-linecap:butt;" /><path d="M 14,29.5 L 14,16.5 L 31,16.5 L 31,29.5 L 14,29.5 z " style="stroke-linecap:butt;stroke-linejoin:miter;" /><path d="M 14,16.5 L 11,14 L 34,14 L 31,16.5 L 14,16.5 z " style="stroke-linecap:butt;" /><path d="M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14 L 11,14 z " style="stroke-linecap:butt;" /><path d="M 12,35.5 L 33,35.5 L 33,35.5" style="fill:none; stroke:#ffe3dc; stroke-width:1; stroke-linejoin:miter;" /><path d="M 13,31.5 L 32,31.5" style="fill:none; stroke:#ffe3dc; stroke-width:1; stroke-linejoin:miter;" /><path d="M 14,29.5 L 31,29.5" style="fill:none; stroke:#ffe3dc; stroke-width:1; stroke-linejoin:miter;" /><path d="M 14,16.5 L 31,16.5" style="fill:none; stroke:#ffe3dc; stroke-width:1; stroke-linejoin:miter;" /><path d="M 11,14 L 34,14" style="fill:none; stroke:#ffe3dc; stroke-width:1; stroke-linejoin:miter;" /></g>',
    wb: '<g style="fill:none; fill-rule:evenodd; stroke:#191917; stroke-width:1.5; stroke-linecap:round; stroke-linejoin:round; " transform="translate(0,0.6)"><g style="fill:#fbf6ea; stroke:#191917; stroke-linecap:butt;"><path d="M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.65,38.99 6.68,38.97 6,38 C 7.35,36.54 9,36 9,36 z"/><path d="M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z"/><path d="M 25 8 A 2.5 2.5 0 1 1 20,8 A 2.5 2.5 0 1 1 25 8 z"/></g><path d="M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18" style="fill:none; stroke:#191917; stroke-linejoin:miter;"/></g>',
    bb: '<g style="fill:none; fill-rule:evenodd; stroke:#191917; stroke-width:1.5; stroke-linecap:round; stroke-linejoin:round; " transform="translate(0,0.6)"><g style="fill:#ff5b45; stroke:#191917; stroke-linecap:butt;"><path d="M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.65,38.99 6.68,38.97 6,38 C 7.35,36.54 9,36 9,36 z"/><path d="M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z"/><path d="M 25 8 A 2.5 2.5 0 1 1 20,8 A 2.5 2.5 0 1 1 25 8 z"/></g><path d="M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18" style="fill:none; stroke:#ffe3dc; stroke-linejoin:miter;"/></g>',
    wn: '<g style="fill:none; fill-rule:evenodd; stroke:#191917; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;" transform="translate(0,0.3)"><path d="M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18" style="fill:#fbf6ea; stroke:#191917;" /><path d="M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10" style="fill:#fbf6ea; stroke:#191917;" /><path d="M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z" style="fill:#191917; stroke:#191917;" /><path d="M 15 15.5 A 0.5 1.5 0 1 1 14,15.5 A 0.5 1.5 0 1 1 15 15.5 z" transform="matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)" style="fill:#191917; stroke:#191917;" /></g>',
    bn: '<g style="fill:none; fill-rule:evenodd; stroke:#191917; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;" transform="translate(0,0.3)"><path d="M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18" style="fill:#ff5b45; stroke:#191917;" /><path d="M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10" style="fill:#ff5b45; stroke:#191917;" /><path d="M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z" style="fill:#ffe3dc; stroke:#ffe3dc;" /><path d="M 15 15.5 A 0.5 1.5 0 1 1 14,15.5 A 0.5 1.5 0 1 1 15 15.5 z" transform="matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)" style="fill:#ffe3dc; stroke:#ffe3dc;" /><path d="M 24.55,10.4 L 24.1,11.85 L 24.6,12 C 27.75,13 30.25,14.49 32.5,18.75 C 34.75,23.01 35.75,29.06 35.25,39 L 35.2,39.5 L 37.45,39.5 L 37.5,39 C 38,28.94 36.62,22.15 34.25,17.66 C 31.88,13.17 28.46,11.02 25.06,10.5 L 24.55,10.4 z " style="fill:#ffe3dc; stroke:none;" /></g>',
    wp: '<path d="m 22.5,9 c -2.21,0 -4,1.79 -4,4 0,0.89 0.29,1.71 0.78,2.38 C 17.33,16.5 16,18.59 16,21 c 0,2.03 0.94,3.84 2.41,5.03 C 15.41,27.09 11,31.58 11,39.5 H 34 C 34,31.58 29.59,27.09 26.59,26.03 28.06,24.84 29,23.03 29,21 29,18.59 27.67,16.5 25.72,15.38 26.21,14.71 26.5,13.89 26.5,13 c 0,-2.21 -1.79,-4 -4,-4 z" style="fill:#fbf6ea; stroke:#191917; stroke-width:1.5; stroke-linecap:round; stroke-linejoin:miter; "/>',
    bp: '<path d="m 22.5,9 c -2.21,0 -4,1.79 -4,4 0,0.89 0.29,1.71 0.78,2.38 C 17.33,16.5 16,18.59 16,21 c 0,2.03 0.94,3.84 2.41,5.03 C 15.41,27.09 11,31.58 11,39.5 H 34 C 34,31.58 29.59,27.09 26.59,26.03 28.06,24.84 29,23.03 29,21 29,18.59 27.67,16.5 25.72,15.38 26.21,14.71 26.5,13.89 26.5,13 c 0,-2.21 -1.79,-4 -4,-4 z" style="fill:#ff5b45; stroke:#191917; stroke-width:1.5; stroke-linecap:round; stroke-linejoin:miter; "/>',
  };
  const TYPES = {King:'k', Queen:'q', Rook:'r', Bishop:'b', Knight:'n', Pawn:'p'};
  // An inline SVG of one piece: White in cream, Black in red. The type is a letter (k q r b n p) or a role name ('Knight').
  runtime.MasteekChessArt = (white, type) => '<svg viewBox="0 0 45 45" aria-hidden="true">' + ART[(white ? 'w' : 'b') + (TYPES[type] || type)] + '</svg>';
  // Markup can ask for a piece by name: data-chess-art="wn" draws the white knight there.
  dom.querySelectorAll('[data-chess-art]').forEach(el => { el.innerHTML = runtime.MasteekChessArt(el.dataset.chessArt[0] === 'w', el.dataset.chessArt.slice(1)); });
})();

// ---- puzzles.js
// Mate in 2: ten puzzles, White to move. Solving three unlocks a €20 code once the visitor leaves an email; play goes on after.
// Each puzzle was checked with python-chess: no mate in 1, exactly one first move that forces mate, and every Black reply
// loses. They run from easiest to hardest. The game plays Black's main reply itself. `moves` lists White's legal moves before move 1 and after that reply,
// so the board can show where a piece may go without a chess engine here.
(() => {
  const PUZZLES = [
    {"fen":"2r3k1/5ppp/3n4/8/8/8/4RPPP/2R3K1","key":"c1c8","reply":"d6c8","mates":["e2e8"],"line":"1.Rxc8+ Nxc8 2.Re8#","moves":["c1a1 c1b1 c1c2 c1c3 c1c4 c1c5 c1c6 c1c7 c1c8 c1d1 c1e1 c1f1 e2a2 e2b2 e2c2 e2d2 e2e1 e2e3 e2e4 e2e5 e2e6 e2e7 e2e8 f2f3 f2f4 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4","e2a2 e2b2 e2c2 e2d2 e2e1 e2e3 e2e4 e2e5 e2e6 e2e7 e2e8 f2f3 f2f4 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4"]},
    {"fen":"1k6/ppp2n2/8/8/5R2/8/1Q3PPP/6K1","key":"b2h8","reply":"f7h8","mates":["f4f8"],"line":"1.Qh8+ Nxh8 2.Rf8#","moves":["b2a1 b2a2 b2a3 b2b1 b2b3 b2b4 b2b5 b2b6 b2b7 b2c1 b2c2 b2c3 b2d2 b2d4 b2e2 b2e5 b2f6 b2g7 b2h8 f2f3 f4a4 f4b4 f4c4 f4d4 f4e4 f4f3 f4f5 f4f6 f4f7 f4g4 f4h4 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4","f2f3 f4a4 f4b4 f4c4 f4d4 f4e4 f4f3 f4f5 f4f6 f4f7 f4f8 f4g4 f4h4 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4"]},
    {"fen":"5r1k/6pp/7N/3Q4/8/8/8/6K1","key":"d5g8","reply":"f8g8","mates":["h6f7"],"line":"1.Qg8+ Rxg8 2.Nf7#","moves":["d5a2 d5a5 d5a8 d5b3 d5b5 d5b7 d5c4 d5c5 d5c6 d5d1 d5d2 d5d3 d5d4 d5d6 d5d7 d5d8 d5e4 d5e5 d5e6 d5f3 d5f5 d5f7 d5g2 d5g5 d5g8 d5h1 d5h5 g1g2 g1h1 g1h2 h6f5 h6f7 h6g4 h6g8","g1f1 g1f2 g1g2 g1h1 g1h2 h6f5 h6f7 h6g4 h6g8"]},
    {"fen":"6k1/1R3pp1/3Q3p/2n2N2/8/8/5PPP/6K1","key":"d6f8","reply":"g8f8","mates":["b7b8"],"line":"1.Qf8+ Kxf8 2.Rb8#","moves":["b7a7 b7b1 b7b2 b7b3 b7b4 b7b5 b7b6 b7b8 b7c7 b7d7 b7e7 b7f7 d6a6 d6b6 d6b8 d6c5 d6c6 d6c7 d6d1 d6d2 d6d3 d6d4 d6d5 d6d7 d6d8 d6e5 d6e6 d6e7 d6f4 d6f6 d6f8 d6g3 d6g6 d6h6 f2f3 f2f4 f5d4 f5e3 f5e7 f5g3 f5g7 f5h4 f5h6 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4","b7a7 b7b1 b7b2 b7b3 b7b4 b7b5 b7b6 b7b8 b7c7 b7d7 b7e7 b7f7 f2f3 f2f4 f5d4 f5d6 f5e3 f5e7 f5g3 f5g7 f5h4 f5h6 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4"]},
    {"fen":"1r5k/n5pp/8/5BR1/8/8/5PPP/B5K1","key":"a1g7","reply":"h8g8","mates":["f5e6"],"line":"1.Bxg7+ Kg8 2.Be6#","moves":["a1b2 a1c3 a1d4 a1e5 a1f6 a1g7 f2f3 f2f4 f5b1 f5c2 f5c8 f5d3 f5d7 f5e4 f5e6 f5g4 f5g6 f5h3 f5h7 g1f1 g1h1 g2g3 g2g4 g5g3 g5g4 g5g6 g5g7 g5h5 h2h3 h2h4","f2f3 f2f4 f5b1 f5c2 f5c8 f5d3 f5d7 f5e4 f5e6 f5g4 f5g6 f5h3 f5h7 g1f1 g1h1 g2g3 g2g4 g5g3 g5g4 g5g6 g5h5 g7a1 g7b2 g7c3 g7d4 g7e5 g7f6 g7f8 g7h6 g7h8 h2h3 h2h4"]},
    {"fen":"6k1/5pp1/1Q5p/1r6/6N1/6R1/5PPP/6K1","key":"g4f6","reply":"g8h8","mates":["b6d8"],"line":"1.Nf6+ Kh8 2.Qd8#","moves":["b6a5 b6a6 b6a7 b6b5 b6b7 b6b8 b6c5 b6c6 b6c7 b6d4 b6d6 b6d8 b6e3 b6e6 b6f6 b6g6 b6h6 f2f3 f2f4 g1f1 g1h1 g3a3 g3b3 g3c3 g3d3 g3e3 g3f3 g3h3 g4e3 g4e5 g4f6 g4h6 h2h3 h2h4","b6a5 b6a6 b6a7 b6b5 b6b7 b6b8 b6c5 b6c6 b6c7 b6d4 b6d6 b6d8 b6e3 b6e6 f2f3 f2f4 f6d5 f6d7 f6e4 f6e8 f6g4 f6g8 f6h5 f6h7 g1f1 g1h1 g3a3 g3b3 g3c3 g3d3 g3e3 g3f3 g3g4 g3g5 g3g6 g3g7 g3h3 h2h3 h2h4"]},
    {"fen":"2k5/pppn4/5Q2/BN2r3/8/8/5PPP/6K1","key":"b5d6","reply":"c7d6","mates":["f6d8"],"line":"1.Nd6+ cxd6 2.Qd8#","moves":["a5b4 a5b6 a5c3 a5c7 a5d2 a5e1 b5a3 b5a7 b5c3 b5c7 b5d4 b5d6 f2f3 f2f4 f6a6 f6b6 f6c6 f6d6 f6d8 f6e5 f6e6 f6e7 f6f3 f6f4 f6f5 f6f7 f6f8 f6g5 f6g6 f6g7 f6h4 f6h6 f6h8 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4","a5b4 a5b6 a5c3 a5c7 a5d2 a5d8 a5e1 f2f3 f2f4 f6d6 f6d8 f6e5 f6e6 f6e7 f6f3 f6f4 f6f5 f6f7 f6f8 f6g5 f6g6 f6g7 f6h4 f6h6 f6h8 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4"]},
    {"fen":"2k5/pppN4/1qQ5/8/8/8/5PPP/3B2K1","key":"d7b6","reply":"a7b6","mates":["c6e8"],"line":"1.Nxb6+ axb6 2.Qe8#","moves":["c6a4 c6b5 c6b6 c6b7 c6c1 c6c2 c6c3 c6c4 c6c5 c6c7 c6d5 c6d6 c6e4 c6e6 c6f3 c6f6 c6g6 c6h6 d1a4 d1b3 d1c2 d1e2 d1f3 d1g4 d1h5 d7b6 d7b8 d7c5 d7e5 d7f6 d7f8 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4","c6a4 c6b5 c6b6 c6b7 c6c1 c6c2 c6c3 c6c4 c6c5 c6c7 c6d5 c6d6 c6d7 c6e4 c6e6 c6e8 c6f3 c6f6 c6g6 c6h6 d1a4 d1b3 d1c2 d1e2 d1f3 d1g4 d1h5 f2f3 f2f4 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4"]},
    {"fen":"1k1r4/ppp1N3/B7/2r3Q1/8/8/5PPP/6K1","key":"e7c6","reply":"c5c6","mates":["g5d8"],"line":"1.Nc6+ Rxc6 2.Qxd8#","moves":["a6b5 a6b7 a6c4 a6d3 a6e2 a6f1 e7c6 e7c8 e7d5 e7f5 e7g6 e7g8 f2f3 f2f4 g1f1 g1h1 g2g3 g2g4 g5c1 g5c5 g5d2 g5d5 g5e3 g5e5 g5f4 g5f5 g5f6 g5g3 g5g4 g5g6 g5g7 g5g8 g5h4 g5h5 g5h6 h2h3 h2h4","a6b5 a6b7 a6c4 a6d3 a6e2 a6f1 f2f3 f2f4 g1f1 g1h1 g2g3 g2g4 g5a5 g5b5 g5c1 g5c5 g5d2 g5d5 g5d8 g5e3 g5e5 g5e7 g5f4 g5f5 g5f6 g5g3 g5g4 g5g6 g5g7 g5g8 g5h4 g5h5 g5h6 h2h3 h2h4"]},
    {"fen":"2k2r2/ppp5/B5q1/1Q2N3/8/8/5PPP/6K1","key":"a6b7","reply":"c8b8","mates":["e5d7"],"line":"1.Bxb7+ Kb8 2.Nd7#","moves":["a6b7 b5a4 b5a5 b5b1 b5b2 b5b3 b5b4 b5b6 b5b7 b5c4 b5c5 b5c6 b5d3 b5d5 b5d7 b5e2 b5e8 b5f1 e5c4 e5c6 e5d3 e5d7 e5f3 e5f7 e5g4 e5g6 f2f3 f2f4 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4","b5a4 b5a5 b5a6 b5b1 b5b2 b5b3 b5b4 b5b6 b5c4 b5c5 b5c6 b5d3 b5d5 b5d7 b5e2 b5e8 b5f1 b7a6 b7a8 b7c6 b7c8 b7d5 b7e4 b7f3 e5c4 e5c6 e5d3 e5d7 e5f3 e5f7 e5g4 e5g6 f2f3 f2f4 g1f1 g1h1 g2g3 g2g4 h2h3 h2h4"]}
  ];
  const UNLOCK_AT = 3, STORE = 'masteek-mate-in-2';
  const NAMES = {k:'king', q:'queen', r:'rook', b:'bishop', n:'knight', p:'pawn'};
  const $ = id => dom.getElementById(id);
  const section = $('puzzleSection'), board = $('puzzleBoard');
  if(!section || !board) return;
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wait = ms => new Promise(done => setTimeout(done, reduced() ? Math.min(ms, 150) : ms));
  const files = 'abcdefgh';
  const squareName = (file, rank) => files[file] + (rank + 1);

  // Progress lives in this browser only: the puzzles solved, whether the code was unlocked, and the run's stats:
  // hints asked for and wrong moves, counted on puzzles not yet solved, shown above the board and in the result at ten.
  let progress = {solved:[], unlocked:false};
  try { progress = Object.assign(progress, JSON.parse(localStorage.getItem(STORE)) || {}); } catch { /* A fresh start. */ }
  progress.solved = progress.solved.filter(i => Number.isInteger(i) && i >= 0 && i < PUZZLES.length);
  progress.stats = {hints:Number(progress.stats?.hints) || 0, mistakes:Number(progress.stats?.mistakes) || 0};
  const save = () => { try { localStorage.setItem(STORE, JSON.stringify(progress)); } catch { /* Progress lasts for this visit. */ } };

  // 64 squares, rank 8 at the top; one button per square, reached with Tab once and then the arrow keys.
  const squares = {};
  for(let rank = 7; rank >= 0; rank--) for(let file = 0; file < 8; file++) {
    const name = squareName(file, rank), cell = dom.createElement('button');
    cell.type = 'button';
    cell.className = 'puzzle-square ' + ((file + rank) % 2 ? 'is-light' : 'is-dark');
    cell.dataset.square = name;
    cell.tabIndex = -1;
    if(file === 0) cell.dataset.rank = rank + 1;
    if(rank === 0) cell.dataset.file = files[file];
    squares[name] = cell;
    board.append(cell);
  }
  const layer = dom.createElement('div');
  layer.className = 'puzzle-pieces';
  layer.setAttribute('aria-hidden', 'true');
  board.append(layer);

  let index = 0, pieces = [], phase = 'key', selected = null, hintLevel = 0, busy = false, lastMove = null, focusSquare = 'e2';
  const puzzle = () => PUZZLES[index];
  const at = square => pieces.find(p => p.square === square);
  const legal = () => puzzle().moves[phase === 'key' ? 0 : 1].split(' ');
  const answer = () => phase === 'key' ? puzzle().key : puzzle().mates[0];
  const san = n => puzzle().line.split(' ')[n].replace(/^\d+\./, '');

  // Mistakes and hints count only on a puzzle not yet solved, so replaying a solved one changes nothing.
  const count = stat => { if(!progress.solved.includes(index)) { progress.stats[stat]++; save(); renderStats(); } };

  function load(i) {
    index = i; phase = 'key'; selected = null; hintLevel = 0; busy = false; lastMove = null;
    layer.replaceChildren();
    pieces = [];
    puzzle().fen.split('/').forEach((row, r) => {
      let file = 0;
      for(const ch of row) {
        if(/\d/.test(ch)) { file += Number(ch); continue; }
        const el = dom.createElement('span');
        const white = ch === ch.toUpperCase(), type = ch.toLowerCase();
        el.className = 'puzzle-piece ' + (white ? 'is-white' : 'is-black');
        el.innerHTML = runtime.MasteekChessArt(white, type);
        pieces.push({type, white, square:squareName(file, 7 - r), el});
        layer.append(el);
        file++;
      }
    });
    turn('Mate in 2');
    status(progress.solved.includes(i) ? 'Solved before. Play it again.' : 'Pick a white piece, then where it goes.');
    board.classList.remove('is-solved');
    hideDone();
    render();
  }

  function render() {
    const targets = selected ? legal().filter(m => m.startsWith(selected)).map(m => m.slice(2)) : [];
    const hint = hintLevel && phase !== 'done' ? answer() : '';
    Object.entries(squares).forEach(([name, cell]) => {
      const piece = at(name);
      cell.classList.toggle('is-selected', name === selected);
      cell.classList.toggle('is-target', targets.includes(name) && !piece);
      cell.classList.toggle('is-capture', targets.includes(name) && Boolean(piece));
      cell.classList.toggle('is-last', Boolean(lastMove) && (lastMove.slice(0, 2) === name || lastMove.slice(2) === name));
      cell.classList.toggle('is-movable', !busy && phase !== 'done' && Boolean(piece && piece.white) && legal().some(m => m.startsWith(name)));
      cell.classList.toggle('is-hint', Boolean(hint) && (hint.slice(0, 2) === name || (hintLevel > 1 && hint.slice(2) === name)));
      cell.tabIndex = name === focusSquare ? 0 : -1;
      cell.setAttribute('aria-label', name + (piece ? ', ' + (piece.white ? 'white ' : 'black ') + NAMES[piece.type] : '')
        + (name === selected ? ', selected' : '') + (targets.includes(name) ? ', can move here' : ''));
    });
    pieces.forEach(p => {
      if(!p.square) { p.el.classList.add('is-taken'); return; }
      p.el.classList.remove('is-taken');
      p.el.style.setProperty('--x', files.indexOf(p.square[0]));
      p.el.style.setProperty('--y', 8 - Number(p.square[1]));
    });
    $('puzzleHint').disabled = phase === 'done' || busy;
    section.classList.toggle('is-solved', phase === 'done');
    renderProgress();
  }

  function renderProgress() {
    const solved = progress.solved.length, unlocked = solved >= UNLOCK_AT;
    $('puzzleCount').textContent = unlocked ? solved + i18n[" of "] + PUZZLES.length + ' solved' : solved + i18n[" of "] + UNLOCK_AT + ' solved to unlock €20 off';
    $('puzzleMeter').style.setProperty('--progress', Math.min(1, solved / UNLOCK_AT));
    $('puzzleDots').querySelectorAll('button').forEach((dot, i) => {
      const done = progress.solved.includes(i);
      dot.classList.toggle('is-solved', done);
      dot.setAttribute('aria-current', String(i === index));
      dot.setAttribute('aria-label', 'Puzzle ' + (i + 1) + (done ? ', solved' : ''));
    });
    // Once unlocked, the code stays in view, also through a fresh run after Play again.
    $('puzzleUnlock').hidden = !unlocked && !progress.unlocked;
    $('puzzleFinish').hidden = solved < PUZZLES.length;
    // The offer bar above the header follows the visitor's progress.
    const offer = $('promoBarText');
    if(offer) offer.textContent = progress.unlocked ? 'Your €20 puzzle code is ready'
      : solved >= UNLOCK_AT ? '€20 off unlocked · leave your email to see the code'
      : solved ? solved + i18n[" of "] + UNLOCK_AT + ' puzzles solved · ' + (UNLOCK_AT - solved) + ' more for €20 off' : 'Solve 3 chess puzzles, get €20 off';
    renderStats();
    $('puzzleForm').hidden = progress.unlocked;
    $('puzzleReward').hidden = !progress.unlocked;
  }

  const status = text => { $('puzzleStatus').textContent = text; };
  // Above the board: which puzzle, whose move, and how many moves are left to mate.
  const turn = left => { $('puzzleTurn').textContent = 'Puzzle ' + (index + 1) + ' · ' + left; };

  // A move: the piece slides over, a piece on the target square is taken.
  function play(move) {
    const mover = at(move.slice(0, 2)), taken = at(move.slice(2));
    if(taken) taken.square = null;
    mover.square = move.slice(2);
    lastMove = move;
    return {mover, taken, from:move.slice(0, 2)};
  }
  function undo({mover, taken, from}, previous) {
    if(taken) taken.square = mover.square;
    mover.square = from;
    lastMove = previous;
  }

  async function tryMove(move) {
    selected = null; busy = true;
    const previous = lastMove, done = play(move);
    render();
    const right = phase === 'key' ? move === puzzle().key : puzzle().mates.includes(move);
    if(!right) {
      count('mistakes');
      status(phase === 'key' ? 'Not quite: Black gets away after that. Try another move.' : "That's not mate yet. Look again.");
      board.classList.add('is-wrong');
      await wait(650);
      board.classList.remove('is-wrong');
      undo(done, previous); busy = false; render();
      return;
    }
    if(phase === 'key') {
      status('Good move. Black replies…');
      await wait(700);
      play(puzzle().reply);
      phase = 'mate'; hintLevel = 0; busy = false;
      turn('Mate in 1');
      status('Black played ' + san(1) + '. Now finish it.');
      render();
      return;
    }
    phase = 'done'; busy = false;
    board.classList.add('is-solved');
    const first = !progress.solved.includes(index);
    if(first) { progress.solved.push(index); save(); }
    const solved = progress.solved.length;
    const reward = first && solved === UNLOCK_AT && !progress.unlocked;
    const finished = first && solved === PUZZLES.length;
    status('Checkmate!' + (reward ? ' · You solved three: your €20 code is ready.' : solved === PUZZLES.length ? ' · All ten solved.' : ''));
    render();
    // Let the mating move land first.
    await wait(550);
    if(phase === 'done') showDone(reward, finished);
  }

  // Solved: a card over the board says so and leads on, to the code the moment it unlocks, else to the next puzzle.
  // The tenth first solve shows the run's result there instead, with a way to share it.
  let doneAction = 'next';
  function showDone(reward, finished) {
    const solved = progress.solved.length;
    doneAction = finished ? 'share' : reward ? 'code' : 'next';
    $('puzzleDoneTitle').textContent = finished ? 'All ten solved!' : 'Checkmate!';
    $('puzzleDoneNote').textContent = finished ? 'Your result' : reward ? '€20 off unlocked'
      : solved < UNLOCK_AT ? solved + i18n[" of "] + UNLOCK_AT + ' solved · ' + (UNLOCK_AT - solved) + ' more for €20 off'
      : solved === PUZZLES.length ? 'All ten solved' : solved + i18n[" of "] + PUZZLES.length + ' solved';
    $('puzzleDoneStats').hidden = !finished;
    $('puzzleDoneGo').firstChild.textContent = finished ? 'Challenge a friend ' : reward ? 'Get my €20 code ' : 'Next puzzle ';
    $('puzzleDoneNext').hidden = !reward;
    $('puzzleDone').hidden = false;
    $('puzzleDoneGo').focus({preventScroll:true});
  }
  const hideDone = () => { $('puzzleDone').hidden = true; };
  function nextPuzzle() {
    const order = PUZZLES.map((_, i) => (index + 1 + i) % PUZZLES.length);
    load(order.find(i => !progress.solved.includes(i)) ?? order[0]);
  }
  $('puzzleDoneGo').addEventListener('click', () => {
    if(doneAction === 'share') { share(); return; }
    if(doneAction === 'next') { nextPuzzle(); return; }
    hideDone();
    $('puzzleUnlock').scrollIntoView({block:'center', behavior:reduced() ? 'instant' : 'smooth'});
    $('puzzleEmail').focus({preventScroll:true});
  }, {signal:eventSignal});
  $('puzzleDoneNext').addEventListener('click', nextPuzzle, {signal:eventSignal});
  $('puzzleDoneView').addEventListener('click', hideDone, {signal:eventSignal});

  // Drag a piece to its square, or tap the piece and then the square. A press that barely moves counts as a tap.
  let drag = null, skipClick = false;
  const squareAt = (x, y) => board.ownerDocument.elementFromPoint(x, y)?.closest('.puzzle-square');
  board.addEventListener('pointerdown', event => {
    if(busy || phase === 'done' || event.button > 0) return;
    const cell = event.target.closest('.puzzle-square.is-movable');
    if(cell) drag = {from:cell.dataset.square, piece:at(cell.dataset.square), x:event.clientX, y:event.clientY, id:event.pointerId, moved:false};
  }, {signal:eventSignal});
  board.addEventListener('pointermove', event => {
    if(!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
    if(!drag.moved) {
      if(Math.hypot(dx, dy) < 6) return;
      drag.moved = true;
      board.setPointerCapture(event.pointerId);
      selected = drag.from; render();
      drag.piece.el.classList.add('is-dragging');
    }
    drag.piece.el.style.translate = dx + 'px ' + dy + 'px';
  }, {signal:eventSignal});
  const endDrag = event => {
    if(!drag || event.pointerId !== drag.id) return;
    const {from, piece, moved} = drag;
    drag = null;
    if(!moved) return;
    skipClick = true; setTimeout(() => { skipClick = false; });
    const to = event.type === 'pointerup' && squareAt(event.clientX, event.clientY)?.dataset.square;
    const move = to && from + to;
    piece.el.classList.remove('is-dragging');
    if(move && to !== from && legal().includes(move)) {
      // Dropped on its square: it stays where the finger let go instead of sliding back first.
      piece.el.classList.add('is-dropped');
      piece.el.style.translate = '';
      tryMove(move);
      requestAnimationFrame(() => requestAnimationFrame(() => piece.el.classList.remove('is-dropped')));
      return;
    }
    // Dropped elsewhere: it slides home and stays picked, so a tap can finish the move.
    piece.el.style.translate = '';
    focusSquare = from;
    render();
  };
  board.addEventListener('pointerup', endDrag, {signal:eventSignal});
  board.addEventListener('pointercancel', endDrag, {signal:eventSignal});

  board.addEventListener('click', event => {
    const cell = event.target.closest('.puzzle-square');
    if(skipClick || !cell || busy || phase === 'done') return;
    const name = cell.dataset.square, piece = at(name);
    focusSquare = name;
    if(selected && selected !== name && legal().includes(selected + name)) { tryMove(selected + name); return; }
    selected = piece && piece.white && selected !== name && legal().some(m => m.startsWith(name)) ? name : null;
    render();
  }, {signal:eventSignal});
  board.addEventListener('keydown', event => {
    const step = {ArrowLeft:[-1, 0], ArrowRight:[1, 0], ArrowUp:[0, 1], ArrowDown:[0, -1]}[event.key];
    if(!step) return;
    event.preventDefault();
    const file = Math.max(0, Math.min(7, files.indexOf(focusSquare[0]) + step[0]));
    const rank = Math.max(0, Math.min(7, Number(focusSquare[1]) - 1 + step[1]));
    focusSquare = squareName(file, rank);
    render();
    squares[focusSquare].focus();
  }, {signal:eventSignal});

  // Hints are unlimited: the first shows which piece to move; the second shows where it goes, then plays it.
  $('puzzleHint').addEventListener('click', async () => {
    if(busy || phase === 'done') return;
    hintLevel = Math.min(2, hintLevel + 1);
    count('hints');
    const move = answer(), piece = NAMES[at(move.slice(0, 2)).type];
    status(hintLevel === 1 ? 'Hint: move the ' + piece + ' on ' + move.slice(0, 2) + '.' : 'Hint: the ' + piece + ' goes to ' + move.slice(2) + '.');
    if(hintLevel === 1) { render(); return; }
    // Hold the board while the hint shows, then make the move as if the visitor had.
    const shown = index;
    selected = move.slice(0, 2); busy = true; render();
    await wait(900);
    if(index !== shown || !busy) return;  // Start over or another puzzle came first.
    busy = false; hintLevel = 0;
    tryMove(move);
  }, {signal:eventSignal});
  $('puzzleRetry').addEventListener('click', () => load(index), {signal:eventSignal});
  // Next goes to the next puzzle not yet solved, wrapping round; with all solved it simply goes on.
  $('puzzleNext').addEventListener('click', nextPuzzle, {signal:eventSignal});
  PUZZLES.forEach((_, i) => {
    const item = dom.createElement('li'), dot = dom.createElement('button');
    dot.type = 'button'; dot.textContent = i + 1;
    dot.addEventListener('click', () => load(i), {signal:eventSignal});
    item.append(dot);
    $('puzzleDots').append(item);
  });

  // The run's mistakes and hints: live above the board, then in the result on the solved card and below the board.
  const plural = (n, word) => n + ' ' + word + (n === 1 ? '' : 's');
  function renderStats() {
    section.querySelectorAll('[data-stat]').forEach(el => { el.textContent = String(progress.stats[el.dataset.stat]); });
  }
  // The run's result, as the share message and as the friend's greeting.
  const result = ({mistakes, hints}) => (mistakes ? plural(mistakes, 'mistake') : 'no mistakes') + ' and ' + (hints ? plural(hints, 'hint') : 'no hints');
  const shareText = () => 'I solved all 10 Masteek Mate in 2 chess puzzles with ' + result(progress.stats) + '. Can you beat that?';
  // The link carries the result to beat (?challenge=mistakes-hints) and is tagged so the store's reports count its visits.
  const shareUrl = () => 'https://masteek.com/?challenge=' + progress.stats.mistakes + '-' + progress.stats.hints
    + '&utm_source=puzzle_share&utm_medium=social&utm_campaign=all_ten#puzzles';
  const shareStatus = text => { $('puzzleShareStatus').textContent = text; if(!$('puzzleDone').hidden) $('puzzleDoneNote').textContent = text; };
  // The phone's share sheet where there is one; otherwise the message and link go on the clipboard.
  async function share() {
    const text = shareText(), url = shareUrl();
    if(navigator.share) {
      try { await navigator.share({title:'Masteek Mate in 2', text, url}); return; }
      catch(error) { if(error.name === 'AbortError') return; }
    }
    try {
      await navigator.clipboard.writeText(text + ' ' + url);
      shareStatus('Copied. Paste it to a friend.');
    } catch {
      shareStatus(text + ' ' + url);
    }
  }
  $('puzzleShare').addEventListener('click', share, {signal:eventSignal});
  // Play again: a fresh run of all ten, to beat the result; the code stays unlocked.
  $('puzzleAgain').addEventListener('click', () => {
    progress.solved = []; progress.stats = {hints:0, mistakes:0}; save();
    $('puzzleShareStatus').textContent = '';
    load(0);
    $('puzzleTurn').scrollIntoView({block:'start', behavior:reduced() ? 'instant' : 'smooth'});
  }, {signal:eventSignal});

  // The offer bar closes for good in this browser.
  try { if(localStorage.getItem('masteek-promo-closed')) $('promoBar').hidden = true; } catch { /* It shows again next visit. */ }
  $('promoBarClose')?.addEventListener('click', () => {
    $('promoBar').hidden = true;
    try { localStorage.setItem('masteek-promo-closed', '1'); } catch { /* Closed for this visit only. */ }
  }, {signal:eventSignal});

  // Puzzle card: once per browser, for someone who has looked at four or more pieces in the galleries and then
  // left the page alone for five seconds. Never for someone who closed the offer bar, has already played, is on the
  // puzzles page, has a piece close-up or the collection open, or has just gone to buy.
  const nudge = $('puzzleNudge');
  if(nudge) {
    const NUDGE_STORE = 'masteek-nudge-shown', seen = new Set();
    let timer = 0, actedAt = -Infinity, buying = false;
    const stored = key => { try { return localStorage.getItem(key); } catch { return null; } };
    const done = () => { nudge.hidden = true; clearTimeout(timer); try { localStorage.setItem(NUDGE_STORE, '1'); } catch { /* Once per visit, then. */ } };
    const allowed = () => !stored(NUDGE_STORE) && !stored('masteek-promo-closed') && !buying
      && !progress.solved.length && !progress.unlocked && !section.classList.contains('is-page')
      && !dom.querySelector('dialog[open]');
    const arm = () => {
      clearTimeout(timer);
      if(seen.size >= 4 && nudge.hidden) timer = setTimeout(showNudge, 5000);
    };
    function showNudge() {
      if(!allowed()) return;
      // Sit above the set page's buy bar when it is showing.
      const bar = $('modernBuyBar');
      nudge.style.setProperty('--nudge-offset', bar && !bar.hidden ? bar.offsetHeight + 12 + 'px' : '0px');
      nudge.hidden = false;
    }
    // A piece counts only when the visitor brought it into view: the pieces the galleries open on do not.
    window.addEventListener('masteek:piece-view', event => {
      if(performance.now() - actedAt > 3000) return;
      seen.add(event.detail);
      arm();
    }, {signal:eventSignal});
    // A touch, click, key or wheel turn is the visitor acting; any of those, or a scroll, means they are still busy,
    // so the five seconds start again. (A scroll alone is not acting: reloading restores the scroll position.)
    ['pointerdown', 'keydown', 'wheel', 'touchmove'].forEach(type => window.addEventListener(type, () => {
      actedAt = performance.now();
      if(timer) arm();
    }, eventOptions({passive:true})));
    window.addEventListener('scroll', () => { if(timer) arm(); }, eventOptions({passive:true}));
    dom.addEventListener('click', event => { if(event.target.closest('.product-cta')) buying = true; });
    $('puzzleNudgeClose').addEventListener('click', done, {signal:eventSignal});
    $('puzzleNudgePlay').addEventListener('click', done, {signal:eventSignal});
  }

  // The code shows once the visitor leaves an email: Shopify's customer form, tagged "puzzle", like the restock sign-up.
  // Opening Shopify's /discount/ link stores the code in this visitor's session, so checkout applies it without typing.
  // The redirect lands on the small cart.js instead of a whole page. Previews have no store to apply it to.
  const applyCode = () => {
    if(/(^|\.)masteek\.com$|\.myshopify\.com$/.test(location.hostname)) fetch('/discount/CHECKMATE20?redirect=%2Fcart.js').catch(() => {});
  };
  const unlock = () => { progress.unlocked = true; save(); renderProgress(); applyCode(); };
  // Coming back on another day: apply it again, since the stored code ends with the session.
  if(progress.unlocked) applyCode();
  const formStatus = text => { $('puzzleFormStatus').textContent = text; };
  // Shopify's spam check (hCaptcha) takes over the form's submit when it binds, adds its token and then calls the
  // form's own submit(): setting that to this sender keeps the sign-up in the page instead of reloading it.
  const puzzleForm = $('puzzleForm');
  const sendEmail = async () => {
    const form = puzzleForm, button = form.querySelector('button');
    button.disabled = true;
    formStatus('');
    try {
      const response = await fetch(form.action, {method:'POST', body:new FormData(form)});
      if(response.url.includes('/challenge')) {
        // Shopify wants a human check: open its check page (re-sending would reuse the spent token, which it refuses);
        // once passed, the store sends them back here with the code shown.
        try { sessionStorage.setItem('masteek-puzzle', '1'); } catch { /* They come back to Home instead. */ }
        location.assign(response.url);
        return;
      }
      if(!response.url.includes('customer_posted=true')) throw new Error('not posted');
      unlock();
    } catch {
      formStatus("Couldn't send that just now. Please try again.");
    } finally {
      button.disabled = false;
    }
  };
  puzzleForm.submit = sendEmail;
  puzzleForm.addEventListener('submit', event => {
    event.preventDefault();
    if(!/(^|\.)masteek\.com$|\.myshopify\.com$/.test(location.hostname)) { unlock(); $('puzzleRewardNote').textContent = 'Preview: no email was sent.'; return; }
    // Once the spam check is bound, its own submit listener gets the token and then calls sendEmail.
    if(!puzzleForm.hasAttribute('data-hcaptcha-bound')) sendEmail();
  }, {signal:eventSignal});

  $('puzzleCopy').addEventListener('click', async () => {
    const code = $('puzzleCode'), button = $('puzzleCopy');
    try {
      await navigator.clipboard.writeText(code.textContent);
      button.textContent = 'Copied';
    } catch {
      // No clipboard here: select the code so it can be copied by hand.
      const range = new Range(); range.selectNodeContents(code);
      const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range);
      button.textContent = 'Selected';
    }
    setTimeout(() => { button.textContent = 'Copy'; }, 2000);
  }, {signal:eventSignal});

  // Shown on Home below the features, and alone on #puzzles; app.js says which.
  function show(mode) {
    // The offer bar points here, so on the puzzles page itself it steps aside.
    $('promoBar')?.classList.toggle('is-away', mode === 'page');
    section.hidden = !mode;
    section.classList.toggle('is-page', mode === 'page');
  }
  window.addEventListener('hashchange', () => { if(location.hash === '#puzzles') runtime.showChessPanel('puzzles'); }, {signal:eventSignal});
  // Shop with €20 off: the code is already applied, so open the Catalog at its top, as the header's Catalog link does.
  $('puzzleShop').addEventListener('click', event => {
    event.preventDefault();
    runtime.showChessPanel('shop');
    window.scrollTo({top:0, left:0, behavior:'instant'});
  }, {signal:eventSignal});
  runtime.MasteekPuzzles = {show, unlock};
  const first = PUZZLES.findIndex((_, i) => !progress.solved.includes(i));
  load(first < 0 ? 0 : first);
  // Someone who followed a friend's challenge link is greeted on their first puzzle with the result to beat.
  const challenge = new URLSearchParams(location.search).get('challenge')?.match(/^(\d{1,3})-(\d{1,3})$/);
  if(challenge) status('A friend solved all ten with ' + result({mistakes:Number(challenge[1]), hints:Number(challenge[2])}) + '. Can you beat that?');
})();

// ---- app.js
(() => {
  const pieces = runtime.PIECES;
  const $ = id => dom.getElementById(id);
  // Home keeps the title the page arrived with (on the store, its search title); other first pages fall back to the site name.
  runtime.MasteekHomeTitle = location.pathname === '/' ? dom.title : i18n["MASTEEK | Chess Collections"];
  let team = 'humans', selectedId = 'reiner', filter = 'all';
  let carouselTeam = null, boardTeam = null, slides = [], slotWidth = 0, frame = 0, settleTimer = 0;
  let dragging = null, touching = false, suppressClickUntil = 0;
  const carousel = $('figureCarousel'), rail = $('aotRail');
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const teamPieces = () => pieces.filter(p => p.team === team);
  const selected = () => pieces.find(p => p.id === selectedId);
  const boardCells = [];

  function art(piece) {
    const el = dom.createElement('span');
    el.className = 'figure-art ' + (piece.image ? 'photo' : 'sprite-art') + (piece.transparent ? ' cutout' : '') + (piece.placeholder ? ' placeholder-card' : '');
    if(piece.aspect || piece.placeholder) el.style.aspectRatio = piece.placeholder ? '0.68' : String(piece.aspect);
    if (piece.image) {
      const img = dom.createElement('img');
      // Opened on another view (see the route-away gate in index.html): lazy must be set before src, or the photo downloads at once.
      if (root.classList.contains('route-away')) img.loading = 'lazy';
      img.src = piece.image; img.alt = piece.name + i18n[" chess piece"]; img.draggable = false;
      img.loading = 'lazy'; img.decoding = 'async';
      el.append(img);
      if(piece.placeholder) {
        el.setAttribute('role', 'img');
        el.setAttribute('aria-label', piece.name + i18n[", final design coming soon"]);
        img.alt = '';
        const caption = dom.createElement('span');
        caption.className = 'placeholder-card-caption'; caption.textContent = i18n["Coming soon"];
        caption.setAttribute('aria-hidden', 'true'); el.append(caption);
      }
    } else {
      el.style.setProperty('--sprite-x', ((piece.sprite % 4) * 100 / 3) + '%');
      el.style.setProperty('--sprite-y', (Math.floor(piece.sprite / 4) * 100) + '%');
      el.setAttribute('role', 'img'); el.setAttribute('aria-label', piece.name + i18n[", placeholder model"]);
    }
    return el;
  }

  function selectPiece(id, focusGallery = false) {
    const piece = pieces.find(p => p.id === id);
    if (!piece) return;
    team = piece.team; selectedId = id;
    if (focusGallery && $('galleryPanel').hidden) showPanel('gallery');
    if (focusGallery) $('collectionHeading').scrollIntoView?.({block:'start',behavior:reducedMotion() ? 'instant' : 'smooth'});
    render();
    centerOn(id);
  }

  // Past the last piece of a side the row runs on into the other side's first piece (and back from the first).
  function move(delta) {
    const list = teamPieces(), other = pieces.filter(p => p.team !== team);
    const i = list.findIndex(p => p.id === selectedId);
    const target = list[i + delta] || (delta > 0 ? other[0] : other[other.length - 1]);
    const current = closestSlide();
    const adjacent = slides[(current?.index ?? i + 2) + delta];
    if (adjacent && adjacent.piece.id === target.id) scrollToSlide(adjacent);
    else if (target.team !== team) crossTo(target.id);
    else centerOn(target.id);
  }

  function slideTarget(slide) {
    return slide.button.offsetLeft + slotWidth / 2 - carousel.clientWidth / 2;
  }

  function scrollToSlide(slide, smooth = true) {
    if (!slide) return;
    carousel.scrollTo({left: slideTarget(slide), behavior:smooth && !reducedMotion() ? 'smooth' : 'instant'});
    if (!smooth || reducedMotion()) updateCarousel();
  }

  function centerOn(id, smooth = true) {
    const candidates = slides.filter(s => s.piece.id === id);
    const slide = candidates.reduce((best, s) => !best || Math.abs(slideTarget(s)-carousel.scrollLeft) < Math.abs(slideTarget(best)-carousel.scrollLeft) ? s : best, null);
    scrollToSlide(slide, smooth);
  }

  function layoutCarousel() {
    if (!carousel.clientWidth) return;
    // Keep one neighbor inside each edge while the selected artwork stays large.
    slotWidth = carousel.clientWidth * .32;
    // Set on the stage so the row height and the arrows can follow the piece size too (carousel.css).
    $('stage').style.setProperty('--figure-width', carousel.clientWidth * (window.matchMedia('(max-width:700px)').matches ? .60 : .50) + 'px');
    carousel.style.setProperty('--figure-height', carousel.clientHeight * .88 + 'px');
    const padding = (carousel.clientWidth - slotWidth) / 2;
    $('carouselTrack').style.paddingLeft = padding + 'px';
    $('carouselTrack').style.paddingRight = padding + 'px';
    slides.forEach(s => {s.button.style.width = slotWidth + 'px';});
    scrollToSlide(slides.find(s => s.piece.id === selectedId && !s.clone), false);
  }

  function buildCarousel() {
    const list = teamPieces(), other = pieces.filter(p => p.team !== team);
    // The two slides either side of the row are the other side's ends, so swiping on shows what comes next.
    const extended = [...other.slice(-2), ...list, ...other.slice(0,2)];
    slides = extended.map((piece,index) => {
      const button = dom.createElement('button');
      button.type = 'button'; button.className = 'carousel-slide';
      button.setAttribute('aria-label', i18n["Select "] + piece.name);
      const image = art(piece); button.append(image);
      const clone = index < 2 || index >= list.length + 2;
      if(clone){button.setAttribute('aria-hidden','true');button.tabIndex=-1;}
      const slide = {piece,button,image,index,clone};
      // A side piece comes to the centre when clicked; the centred one stays put (the close-up opens from All pieces).
      button.addEventListener('click', () => {
        if(performance.now() < suppressClickUntil) return;
        if(Math.abs(slideTarget(slide)-carousel.scrollLeft) >= slotWidth*.12) scrollToSlide(slide);
      }, {signal:eventSignal});
      button.addEventListener('focus', () => {if(!dragging)scrollToSlide(slide);}, {signal:eventSignal});
      return slide;
    });
    $('carouselTrack').replaceChildren(...slides.map(s => s.button));
    carouselTeam = team;
    rail.style.setProperty('--steps', list.length);
    layoutCarousel();
  }

  function closestSlide() {
    return slides.reduce((best,s) => !best || Math.abs(slideTarget(s)-carousel.scrollLeft) < Math.abs(slideTarget(best)-carousel.scrollLeft) ? s : best, null);
  }

  function updateCarousel() {
    if(!slotWidth) return;
    slides.forEach(slide => {
      const distance = Math.abs((slideTarget(slide)-carousel.scrollLeft)/slotWidth);
      const depth = Math.min(distance,1);
      slide.image.style.transform = 'scale(' + (1 - .38*depth - .06*Math.min(Math.max(distance-1,0),1)) + ')';
      slide.image.style.opacity = String(Math.max(0,(1-.36*depth)*(1-2*Math.max(distance-1,0))));
      slide.image.style.setProperty('--depth-blur', (reducedMotion() ? 0 : Math.min(distance,2)*.7) + 'px');
      // The centred piece glows like a lit piece on the board; the glow fades as it moves aside.
      slide.image.style.setProperty('--lit', (Math.max(0, 1 - distance*2.5)*.6).toFixed(3));
      slide.button.style.zIndex = String(100-Math.round(distance*10));
    });
    // Rail marker: the centred position among this side's pieces, following the row continuously.
    const n = teamPieces().length;
    let at = (carousel.scrollLeft - slideTarget(slides[2])) / slotWidth;
    at = ((at % n) + n) % n;
    if(at > n - 1) at = at - (n - 1) < .5 ? n - 1 : 0;
    rail.style.setProperty('--rail', (at / (n - 1)).toFixed(4));
    const nearest = closestSlide();
    // The other side's pieces at the ends take over only once the row settles on one (settleCarousel).
    if(nearest && nearest.piece.team === team && nearest.piece.id !== selectedId){selectedId=nearest.piece.id;renderDetails();}
  }

  function settleCarousel() {
    if(dragging || touching) return;
    const nearest = closestSlide();
    if(!nearest) return;
    const aligned = Math.abs(slideTarget(nearest)-carousel.scrollLeft)<2;
    if(!aligned){scrollToSlide(nearest);return;}
    if(nearest.clone) crossTo(nearest.piece.id);
  }

  // Settling on (or stepping to) the other side's piece switches sides: the row is rebuilt for that side, centred on it.
  function crossTo(id) {
    const piece = pieces.find(p => p.id === id);
    if(!piece) return;
    team = piece.team; selectedId = id;
    render();
  }

  function render() {
    if(carouselTeam !== team) buildCarousel();
    renderDetails();
  }

  function renderDetails() {
    if(boardTeam !== team) renderBoard();
    const piece = selected(), list = teamPieces(), i = list.indexOf(piece);
    window.dispatchEvent(new CustomEvent('masteek:piece-view', {detail:'aot:' + piece.id}));
    dom.querySelectorAll('[data-team]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.team === team)));
    $('pieceName').textContent = piece.name;
    $('pieceRole').textContent = piece.role + (piece.quantity > 1 ? ' · ' + piece.quantity + i18n[" pieces in the set"] : '');
    $('pieceCount').textContent = (i + 1) + ' / ' + list.length;
    $('modelStatus').textContent = piece.description || (piece.placeholder ? i18n["Placeholder model · final design coming later"] : '');
    updateBoardSelection();
  }

  function updateBoardSelection() {
    boardCells.forEach(({id,cell}) => {
      const active = id === selectedId;
      cell.setAttribute('aria-pressed', String(active));
    });
  }

  function showPanel(panel) {
    const gallery = panel === 'gallery', shop = panel === 'shop', puzzles = panel === 'puzzles';
    dom.title = puzzles ? 'Mate in 2 puzzles | MASTEEK' : runtime.MasteekHomeTitle;
    $('videoHero').hidden = !gallery;
    $('galleryPanel').hidden = !gallery; $('shopPanel').hidden = !shop;
    $('galleryNav').classList.toggle('active', gallery);
    $('galleryNav').setAttribute('aria-current', gallery ? 'page' : 'false');
    $('shopNav').classList.toggle('active', shop);
    $('shopNav').setAttribute('aria-current', shop ? 'page' : 'false');
    history.replaceState(null, '', gallery ? '#home' : shop ? '#catalog' : '#puzzles');
    if(gallery) runtime.MasteekCollections?.showHome();
    else runtime.MasteekCollections?.showCatalog(null);
    // The puzzles close Home and fill their own page, #puzzles, which no menu item names.
    runtime.MasteekPuzzles?.show(gallery ? 'home' : puzzles ? 'page' : null);
    if(puzzles) window.scrollTo(0, 0);
    if(gallery && slides.length) layoutCarousel();
    if(shop) runtime.MasteekCatalog?.openOverview();
  }

  // The collection dialog groups pieces under one heading per team, so cards name only the role; the placeholder
  // note is said once above the groups instead of under every unfinished piece. Each card shows the piece's note,
  // and opens the piece's close-up on top of the grid, so closing it returns to the collection, not to Home.
  function renderCatalog() {
    dom.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.filter === filter)));
    const card = p => {
      const button = dom.createElement('button'); button.type = 'button'; button.className = 'catalog-card';
      button.setAttribute('aria-label', i18n["View: "] + p.name + ', ' + p.role + (p.placeholder ? i18n[", placeholder model"] : ''));
      const image = dom.createElement('div'); image.className = 'catalog-art'; image.append(art(p));
      const name = dom.createElement('h4'); name.textContent = p.name;
      const role = dom.createElement('p'); role.textContent = p.role + (p.quantity > 1 ? ' · ×' + p.quantity : '');
      button.append(image, name, role);
      if (p.description) {const note = dom.createElement('p'); note.className = 'piece-note'; note.textContent = p.description; button.append(note);}
      button.addEventListener('click', () => { selectPiece(p.id); openZoom(); }, {signal:eventSignal});
      return button;
    };
    const teams = [['humans', i18n["Humanity"]], ['titans', i18n["Titans"]]].filter(([team]) => filter === 'all' || filter === team);
    const shown = pieces.filter(p => teams.some(([team]) => team === p.team));
    $('catalogNote').hidden = !shown.some(p => p.placeholder);
    $('catalogGrid').replaceChildren(...teams.map(([team, label]) => {
      const group = dom.createElement('section'); group.className = 'catalog-group';
      group.setAttribute('aria-labelledby', 'catalogGroup-' + team);
      const heading = dom.createElement('h3'); heading.className = 'catalog-group-title'; heading.id = 'catalogGroup-' + team; heading.textContent = label;
      const grid = dom.createElement('div'); grid.className = 'catalog-grid';
      grid.append(...pieces.filter(p => p.team === team).map(card));
      group.append(heading, grid);
      return group;
    }));
  }

  function openCatalog() {filter = 'all'; renderCatalog(); runtime.MasteekDialogs.open($('catalogDialog'));}
  function openZoom() {
    // The closer look opens the full-size photo; the slideshow shows the smaller copy in p.image.
    const p = selected(), photos = p.images || [p.image];
    $('zoomArt').replaceChildren(art({...p, image:photos[0]})); $('zoomName').textContent = p.name;
    // Where this piece sits among its side's pieces, the order the arrows step through.
    const side = teamPieces(), place = side.findIndex(piece => piece.id === p.id) + 1;
    $('zoomRole').textContent = p.role + (p.placeholder ? i18n[" · Placeholder model"] : '') + ' · ' + place + i18n[" of "] + side.length;
    $('zoomDescription').textContent = p.description || '';
    $('zoomDescription').hidden = !p.description;
    const options = photos.map((src, index) => {
      const button = dom.createElement('button'); button.type = 'button';
      button.textContent = String(index + 1);
      button.setAttribute('aria-label', p.name + i18n[", model "] + (index + 1));
      button.setAttribute('aria-pressed', String(index === 0));
      button.addEventListener('click', () => {
        $('zoomArt').replaceChildren(art({...p, image:src}));
        options.forEach((option, optionIndex) => option.setAttribute('aria-pressed', String(optionIndex === index)));
      }, {signal:eventSignal});
      return button;
    });
    $('zoomPhotos').replaceChildren(...options); $('zoomPhotos').hidden = photos.length < 2;
    runtime.MasteekZoomShow({set:'aot', step:delta => {
      const list = teamPieces(), i = list.findIndex(piece => piece.id === selectedId);
      selectPiece(list[(i + delta + list.length) % list.length].id);
      openZoom();
    }});
  }

  function renderBoard() {
    const ranks = [
      ['beast','jaw','warhammer','attack','founding','warhammer-2','female','cart'],
      ['smiling','colossal-pawn-2','colossal-pawn','colossal-pawn-3','colossal-pawn-4','colossal-pawn-5','colossal-pawn-6','pure'],
      [],[],[],[], // the middle of the board: empty at the start of a game
      ['reiner','sasha','connie','eren','bertholdt','ymir','hange','pixis'],
      ['armored','jean','levi','historia','erwin','mikasa','armin','colossal']
    ];
    // The gallery's picker shows the selected team's two starting ranks, one chess piece per square: Humanity in cream, Titans in red.
    boardCells.length = 0;
    const rows = team === 'humans' ? [7,6] : [0,1];
    const cells = [];
    for (const row of rows) for (let col=0; col<8; col++) {
      const id=ranks[row][col], p=pieces.find(p=>p.id===id);
      const cell=dom.createElement('button');
      const square=String.fromCharCode(97+col)+(8-row);
      cell.className='board-cell'+((row+col)%2 ? ' dark' : '')+(p.team==='titans' ? ' titan' : '');
      cell.type='button';cell.dataset.pieceId=id;
      cell.setAttribute('aria-label',p.name+', '+p.role+', '+square);
      const icon=dom.createElement('span');icon.className='chess-icon';icon.innerHTML=runtime.MasteekChessArt(p.team!=='titans',p.role);icon.setAttribute('aria-hidden','true');cell.append(icon);
      cell.addEventListener('click',()=>selectPiece(p.id,true), {signal:eventSignal});
      boardCells.push({id,cell,square});
      cells.push(cell);
    }
    $('selectionBoard').replaceChildren(...cells);
    boardTeam = team;
    updateBoardSelection();
  }

  const switchSide = next => {
    if(next === team) return;
    team = next; selectedId = team === 'humans' ? 'reiner' : 'smiling'; render();
  };
  dom.querySelectorAll('[data-team]').forEach(b=>b.addEventListener('click',()=>switchSide(b.dataset.team), {signal:eventSignal}));
  $('sideSwap').addEventListener('click',()=>switchSide(team === 'humans' ? 'titans' : 'humans'), {signal:eventSignal});

  dom.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{filter=b.dataset.filter;renderCatalog();}, {signal:eventSignal}));
  $('prevButton').addEventListener('click',()=>move(-1), {signal:eventSignal});
  $('nextButton').addEventListener('click',()=>move(1), {signal:eventSignal});
  $('allButton').addEventListener('click',openCatalog, {signal:eventSignal}); $('desktopAllButton').addEventListener('click',openCatalog, {signal:eventSignal});
  $('galleryNav').addEventListener('click',()=>{showPanel('gallery');window.scrollTo?.({top:0,left:0,behavior:reducedMotion() ? 'instant' : 'smooth'});}, {signal:eventSignal});
  $('shopNav').addEventListener('click',()=>{showPanel('shop');window.scrollTo?.({top:0,left:0,behavior:reducedMotion() ? 'instant' : 'smooth'});}, {signal:eventSignal});
  dom.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>$(b.dataset.close).close(), {signal:eventSignal}));
  for(const dialog of [$('catalogDialog'),$('zoomDialog'),$('productZoomDialog')]) {
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}}, {signal:eventSignal});
  }
  dom.addEventListener('keydown',e=>{
    if(e.target && ['INPUT','TEXTAREA','SELECT'].includes(e.target.tagName)) return;
    if(e.defaultPrevented || e.target?.closest?.('.home-modern-section, .modern-gallery')) return;
    if($('catalogDialog').open||$('zoomDialog').open||$('galleryPanel').hidden) return;
    if(e.key==='ArrowLeft'){e.preventDefault();move(-1);}if(e.key==='ArrowRight'){e.preventDefault();move(1);}
  });
  carousel.addEventListener('scroll',()=>{
    if(!frame)frame=requestAnimationFrame(()=>{frame=0;updateCarousel();});
    clearTimeout(settleTimer);settleTimer=setTimeout(settleCarousel,180);
  }, eventOptions({passive:true}));
  carousel.addEventListener('touchstart',()=>{touching=true;}, eventOptions({passive:true}));
  function endTouch(){touching=false;clearTimeout(settleTimer);settleTimer=setTimeout(settleCarousel,180);}
  carousel.addEventListener('touchend',endTouch, eventOptions({passive:true}));
  carousel.addEventListener('touchcancel',endTouch, eventOptions({passive:true}));
  carousel.addEventListener('pointerdown',e=>{
    if(e.pointerType!=='mouse'||e.button!==0)return;
    dragging={x:e.clientX,scroll:carousel.scrollLeft,pointer:e.pointerId,moved:false};
  }, {signal:eventSignal});
  carousel.addEventListener('pointermove',e=>{
    if(!dragging)return;
    const delta=e.clientX-dragging.x;
    if(Math.abs(delta)>5){dragging.moved=true;carousel.classList.add('is-dragging');carousel.setPointerCapture(e.pointerId);}
    if(dragging.moved){e.preventDefault();carousel.scrollLeft=dragging.scroll-delta;updateCarousel();}
  }, {signal:eventSignal});
  function endDrag(){
    if(!dragging)return;
    const moved=dragging.moved,pointer=dragging.pointer;dragging=null;
    if(carousel.hasPointerCapture(pointer))carousel.releasePointerCapture(pointer);
    carousel.classList.remove('is-dragging');
    if(moved){suppressClickUntil=performance.now()+300;scrollToSlide(closestSlide());}
  }
  carousel.addEventListener('pointerup',endDrag, {signal:eventSignal});carousel.addEventListener('pointercancel',endDrag, {signal:eventSignal});
  carousel.addEventListener('pointerleave',()=>{if(dragging&&!dragging.moved)dragging=null;}, {signal:eventSignal});
  new ResizeObserver(()=>layoutCarousel()).observe(carousel);
  // The first time the slideshow is in view, slide the row a little way and back so it reads as swipeable.
  // Runs once, never under reduced motion, and stops as soon as the visitor touches the row.
  let nudged = false, nudgeFrame = 0, nudgeStart = 0;
  function stopNudge() {
    nudged = true;
    if(!nudgeFrame) return;
    cancelAnimationFrame(nudgeFrame); nudgeFrame = 0;
    carousel.scrollLeft = nudgeStart; carousel.classList.remove('is-nudging'); updateCarousel();
  }
  function nudge() {
    if(nudged || reducedMotion() || $('galleryPanel').hidden || !slotWidth) return;
    nudged = true;
    nudgeStart = carousel.scrollLeft;
    const reach = slotWidth * .45, began = performance.now(), length = 1300;
    carousel.classList.add('is-nudging');
    const step = now => {
      const t = Math.min(1, (now - began) / length);
      carousel.scrollLeft = nudgeStart + reach * Math.sin(Math.PI * t) ** 2;
      if(t < 1) nudgeFrame = requestAnimationFrame(step);
      else {nudgeFrame = 0; carousel.scrollLeft = nudgeStart; carousel.classList.remove('is-nudging'); updateCarousel();}
    };
    nudgeFrame = requestAnimationFrame(step);
  }
  ['pointerdown','touchstart','wheel'].forEach(type => carousel.addEventListener(type, stopNudge, eventOptions({passive:true})));
  dom.addEventListener('keydown', () => {if(nudgeFrame) stopNudge();});
  if(typeof IntersectionObserver === 'function') {
    const seen = new IntersectionObserver(entries => {
      if(nudged) {seen.disconnect(); return;}
      if(entries.some(e => e.isIntersecting && e.intersectionRatio >= .6)) setTimeout(() => {nudge(); if(nudged) seen.disconnect();}, 350);
    }, {threshold:.6});
    seen.observe($('stage'));
  }
  function setupLightComparison(prefix) {
    const lightRange = $(prefix + 'LightRange'), lightComparison = $(prefix + 'LightComparison');
    const lightGesture = $(prefix + 'LightGesture');
    const touchScreen = () => window.matchMedia('(pointer:coarse)').matches;
    let lightIntroPlayed = false, lightIntroObserver = null, lightIntroTimers = [];
    let lightDrag = null, lightMotionFrame = 0;
    function setLightReveal(value) {
      const reveal = Math.max(0, Math.min(100, Number(value)));
      lightRange.value = String(reveal);
      lightComparison.style.setProperty('--reveal', reveal + '%');
      const percent = Math.round(reveal);
      lightRange.setAttribute('aria-valuetext', percent + i18n["% lights on, "] + (100 - percent) + i18n["% lights off"]);
    }
    function stopLightIntro() {
      lightIntroPlayed = true;
      lightIntroTimers.forEach(clearTimeout); lightIntroTimers = [];
      lightIntroObserver?.disconnect();
      lightComparison.style.setProperty('--reveal-duration', '0s');
    }
    function playLightIntro() {
      if(lightIntroPlayed || reducedMotion() || touchScreen()) return;
      lightIntroPlayed = true;
      lightComparison.style.setProperty('--reveal-duration', '0.5s');
      for(const [delay,value] of [[100,40],[600,60],[1100,50]]) {
        lightIntroTimers.push(setTimeout(() => setLightReveal(value), delay));
      }
      lightIntroTimers.push(setTimeout(() => {
        lightComparison.style.setProperty('--reveal-duration', '0s');
        lightIntroTimers = [];
      },1600));
    }
    function stopLightMotion() {
      cancelAnimationFrame(lightMotionFrame);
      lightMotionFrame = 0;
    }
    function releaseLightDrag(event) {
      if(!lightDrag || event.pointerId !== lightDrag.pointer) return;
      const samples = lightDrag.samples;
      const horizontal = lightDrag.axis === 'x';
      lightDrag = null;
      if(!horizontal || reducedMotion() || samples.length < 2) return;
      const first = samples[0], last = samples.at(-1), now = performance.now();
      if(now - last.time > 80 || last.time - first.time < 8) return;
      const velocity = Math.max(-.08, Math.min(.08, (last.value - first.value) / (last.time - first.time)));
      const start = Number(lightRange.value);
      const end = Math.max(0, Math.min(100, start + velocity * 120));
      if(Math.abs(end - start) < .15) return;
      function coast(time) {
        const progress = Math.min(1, (time - now) / 360);
        setLightReveal(start + (end - start) * (1 - Math.pow(1 - progress, 3)));
        lightMotionFrame = progress < 1 ? requestAnimationFrame(coast) : 0;
      }
      lightMotionFrame = requestAnimationFrame(coast);
    }
    function recordLightSample() {
      if(lightDrag) {
        const time = performance.now();
        const value = Number(lightRange.value), samples = lightDrag.samples;
        if(samples.length > 1 && (value - samples.at(-1).value) * (samples.at(-1).value - samples.at(-2).value) < 0) {
          lightDrag.samples = [samples.at(-1)];
        }
        lightDrag.samples.push({value, time});
        lightDrag.samples = lightDrag.samples.filter(sample => time - sample.time <= 100);
      }
    }
    lightRange.addEventListener('input', () => {
      stopLightIntro(); stopLightMotion(); lightDrag = null;
      setLightReveal(lightRange.value);
    }, {signal:eventSignal});
    // A separate touch surface keeps the native range from moving during page scrolling.
    lightGesture.addEventListener('pointerdown', event => {
      if(event.button !== 0 || !event.isPrimary) return;
      stopLightIntro(); stopLightMotion();
      const rect = lightComparison.getBoundingClientRect();
      const touch = event.pointerType === 'touch';
      lightDrag = {pointer:event.pointerId, touch, axis:touch ? null : 'x', x:event.clientX, y:event.clientY, start:Number(lightRange.value), left:rect.left, width:rect.width, samples:[]};
      if(!touch) {
        event.preventDefault();
        lightRange.focus({preventScroll:true});
        lightGesture.setPointerCapture(event.pointerId);
        setLightReveal((event.clientX - rect.left) / rect.width * 100);
      }
      recordLightSample();
    }, {signal:eventSignal});
    lightGesture.addEventListener('pointermove', event => {
      if(!lightDrag || lightDrag.pointer !== event.pointerId) return;
      const drag = lightDrag, dx = event.clientX - drag.x, dy = event.clientY - drag.y;
      if(drag.touch && !drag.axis) {
        if(Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
        if(Math.abs(dy) >= Math.abs(dx)) {drag.axis = 'y'; return;}
        if(Math.abs(dx) < Math.abs(dy) * 1.2) return;
        drag.axis = 'x';
        lightGesture.setPointerCapture(event.pointerId);
        lightRange.focus({preventScroll:true});
      }
      if(drag.axis !== 'x' || !drag.width) return;
      if(event.cancelable) event.preventDefault();
      setLightReveal(drag.touch ? drag.start + dx / drag.width * 100 : (event.clientX - drag.left) / drag.width * 100);
      recordLightSample();
    }, {signal:eventSignal});
    window.addEventListener('pointerup', releaseLightDrag, {signal:eventSignal});
    window.addEventListener('pointercancel', event => {
      if(lightDrag?.pointer === event.pointerId) {lightDrag = null; stopLightMotion();}
    }, {signal:eventSignal});
    lightRange.addEventListener('keydown', () => {stopLightIntro(); stopLightMotion(); lightDrag = null;}, {signal:eventSignal});
    window.addEventListener('blur', () => {lightDrag = null; stopLightMotion();}, {signal:eventSignal});
    if(typeof IntersectionObserver === 'function' && !reducedMotion() && !touchScreen()) {
      lightIntroObserver = new IntersectionObserver(entries => {
        if(lightIntroPlayed || !entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .5)) return;
        lightIntroObserver.disconnect();
        lightIntroTimers.push(setTimeout(playLightIntro,300));
      },{root:null,rootMargin:'0px',threshold:.5});
      lightIntroObserver.observe(lightComparison);
    }
  }
  setupLightComparison('aot');
  setupLightComparison('modern');
  setupLightComparison('original');
  runtime.showChessPanel = showPanel;
  runtime.MasteekAot = {layout:layoutCarousel};
  // A product page's address, or a retired alias such as #full-set, opens that set in the Catalog.
  // Back from Shopify's human check after a restock sign-up: reopen that set's page, where the form thanks them.
  try {
    const restockId = new URLSearchParams(location.search).get('customer_posted') === 'true' && sessionStorage.getItem('masteek-restock');
    const restockSet = restockId && runtime.MASTEEK_PRODUCTS.find(p => p.id === restockId);
    sessionStorage.removeItem('masteek-restock');
    if(restockSet) {history.replaceState(null, '', location.pathname + restockSet.page.hash); runtime.MasteekRestockThanks = true;}
    // Back from the same check after leaving an email for the puzzle code: reopen the puzzles with the code shown.
    const puzzle = new URLSearchParams(location.search).get('customer_posted') === 'true' && sessionStorage.getItem('masteek-puzzle');
    sessionStorage.removeItem('masteek-puzzle');
    if(puzzle) {history.replaceState(null, '', location.pathname + '#puzzles'); runtime.MasteekPuzzles?.unlock(); runtime.MasteekPuzzleReturn = true;}
  } catch { /* Without storage the visitor stays on the page Shopify returned them to. */ }
  runtime.MasteekInitialProduct = initialProduct || runtime.MASTEEK_PRODUCTS.find(p => p.page?.hash === location.hash || p.aliases?.includes(location.hash))?.id || null;
  const initialPanel = location.hash === '#catalog' || runtime.MasteekInitialProduct ? 'shop' : location.hash === '#puzzles' ? 'puzzles' : 'gallery';
  render(); showPanel(initialPanel);
  // Land on the code itself rather than the top of the puzzles.
  if(runtime.MasteekPuzzleReturn) requestAnimationFrame(() => $('puzzleReward')?.scrollIntoView({block:'center'}));
})();

// ---- catalog.js
(() => {
  const products = runtime.MASTEEK_PRODUCTS;
  const $ = id => dom.getElementById(id);
  const carousel = $('productCarousel');
  const overview = $('collectionOverview'), detail = $('collectionDetail');
  let selectedId = products[0].id, lights = 'on', photoIndex = 0, slides = [], photoButtons = [], slot = 0, frame = 0, timer = 0;
  let dragging = null, touching = false, suppressClickUntil = 0;
  const selected = () => products.find(p => p.id === selectedId);
  // Sets with a "page" (Modern, Original) get the full product page; AOT keeps the coverflow and its own sections.
  const page = p => Boolean(p.page);
  // A product page shows one photo at a time; the other sets keep the coverflow.
  const flat = () => page(selected());
  // Home's offer blocks, by the id prefix of their elements.
  const homeOffers = {aot:'homeAot', modern:'homeModern', original:'homeOriginal'};
  const photos = () => selected().photos || [{src:selected().image, light:'on'}, ...(selected().offImage ? [{src:selected().offImage, light:'off'}] : [])];
  const source = () => photos()[photoIndex] || photos()[0];
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // The store converts prices for each market (a US visitor gets dollars), so the symbol and label follow its currency.
  const currency = runtime.MasteekCurrency || 'EUR';
  const money = value => new Intl.NumberFormat({EUR:'en-IE', USD:'en-US', GBP:'en-GB', AUD:'en-AU', CAD:'en-CA'}[currency] || navigator.language || 'en',
    {style:'currency', currency, currencyDisplay:'narrowSymbol', minimumFractionDigits:value % 1 ? 2 : 0, maximumFractionDigits:value % 1 ? 2 : 0}).format(value);
  dom.querySelectorAll('.product-price small, .collection-card-price small').forEach(label => {label.textContent = currency;});
  // The store fills in each set's live stock; a set in stock says how many are left once only a few are.
  const lowStock = product => Number.isFinite(product.stock) && product.stock > 0 && product.stock <= 5;
  const purchaseUrl = product => product.available && product.checkoutUrl ? product.checkoutUrl : product.url;
  const saving = product => {
    const amount = product.saving ?? (product.comparePrice > product.price ? product.comparePrice - product.price : 0);
    return amount > 0 ? i18n["Save "] + money(amount) : '';
  };
  const showSaving = (id,product) => {$(id).textContent = saving(product); $(id).hidden = !saving(product);};
  const cartUrl = id => '/cart/' + id + ':1';
  // A set's page can add another set's pieces; the pick is remembered per set while the visitor browses.
  const addOnChoice = {};
  const addOnFor = product => (product.addOns || []).find(a => a.available && a.pieces === addOnChoice[product.id]) || null;
  // What the buy buttons sell: the set alone, or the Shopify bundle of the set and the picked pieces.
  const offer = product => {
    const addOn = addOnFor(product);
    if(!addOn) return {price:product.price, comparePrice:product.comparePrice, available:product.available, checkoutUrl:product.checkoutUrl, url:product.url, name:product.subtitle, breakdown:null};
    const pieces = products.find(set => set.id === addOn.pieces);
    const setCompare = product.comparePrice > product.price ? product.comparePrice : null;
    // The bundle has no earlier price of its own, so its total is not struck through. The saving is the set's: the
    // breakdown strikes through the set's own earlier price, and the badge shows that difference.
    return {price:product.price + addOn.price, comparePrice:null, saving:setCompare ? setCompare - product.price : 0, available:product.available,
      checkoutUrl:addOn.checkoutUrl, url:product.url, name:product.subtitle + ' + ' + pieces.name + ' pieces',
      breakdown:{setCompare, setPrice:product.price, pieces:addOn.price}};
  };
  const showBreakdown = (id,sale) => {
    const b = sale.breakdown;
    $(id).hidden = !b;
    $(id).replaceChildren(...(b ? [...(b.setCompare ? [Object.assign(dom.createElement('s'), {textContent:money(b.setCompare)}), ' '] : []),
      money(b.setPrice) + ' set + ' + money(b.pieces) + ' pieces'] : []));
  };
  const target = s => s.button.offsetLeft + slot / 2 - carousel.clientWidth / 2;

  function details() {
    const p = selected();
    updateCards();
    $('productName').textContent = page(p) ? p.subtitle : p.name;
    $('productSubtitle').textContent = p.subtitle;
    $('productSubtitle').hidden = page(p);
    $('productStage').classList.toggle('modern-product-stage',page(p));
    $('productDescription').textContent = p.description;
    photoDetails();
    $('productAvailability').textContent = page(p)
      ? (p.available ? (p.preorder ? 'Pre-order · ships from ' + p.preorder : lowStock(p) ? 'Only ' + p.stock + ' left in stock' : i18n["In stock"]) : i18n["Sold out"])
      : (p.available ? i18n["Available at Masteek"] : i18n["In development · not yet available"]);
    $('productAvailability').dataset.available = String(p.available);
    $('productAvailability').dataset.preorder = String(Boolean(p.preorder));
    // A limited set counts down: the store fills in its live stock, previews show the full edition.
    const left = Number.isFinite(p.stock) ? p.stock : p.edition;
    $('productEdition').hidden = !(page(p) && p.edition && p.available && left > 0);
    $('productEditionCount').textContent = left === 1 ? 'Last of ' + p.edition : left + i18n[" of "] + p.edition + ' left';
    $('productEditionBar').style.width = (p.edition ? Math.min(100, left / p.edition * 100) : 0) + '%';
    // Product pages go without the lights toggle; their photo rows already include a lights-off shot.
    $('lightControls').hidden = !p.offImage || page(p);
    $('modernProductInfo').hidden = $('modernProductPerks').hidden = $('modernPriceNote').hidden = $('modernBacked').hidden = !page(p);
    if(!page(p)) $('productNote').hidden = true;
    $('meetCharacters').hidden = !(page(p) && p.page.characterGallery);
    if(page(p)) pageDetails(p);
    Object.entries(homeOffers).forEach(([id,prefix]) => {
      const set = products.find(product => product.id === id);
      $(prefix + 'Price').textContent = money(set.price);
      $(prefix + 'Compare').hidden = !set.comparePrice;
      $(prefix + 'Compare').textContent = set.comparePrice ? money(set.comparePrice) : '';
      showSaving(prefix + 'Save',set);
      // Home only flags a set when it cannot be bought; the button already covers the in-stock case.
      $(prefix + 'Availability').hidden = set.available;
      const preorder = $(prefix + 'Preorder');
      if(preorder) {preorder.hidden = !(set.available && set.preorder); preorder.textContent = 'Pre-order · ships from ' + set.preorder;}
      $(prefix + 'StoreLink').href = set.page.hash;
      $(prefix + 'StoreLink').replaceChildren(dom.createTextNode(i18n["Shop this set "]), Object.assign(dom.createElement('span'),{textContent:'→'}));
    });
    // The hero's price fact shows the cheapest set on sale, with its earlier price struck through when it has one.
    const onSale = products.filter(product => page(product) && product.available);
    if(onSale.length) {
      const lowest = onSale.reduce((a,b) => b.price < a.price ? b : a);
      $('heroPrice').textContent = money(lowest.price);
      $('heroCompare').hidden = !(lowest.comparePrice > lowest.price);
      $('heroCompare').textContent = lowest.comparePrice > lowest.price ? money(lowest.comparePrice) : '';
    }
    addOnPicker(p);
    showOffer();
  }

  // A set, or a set with added pieces, that includes a pre-order: its buttons say so.
  const preordered = product => Boolean(product.preorder || products.find(set => set.id === addOnFor(product)?.pieces)?.preorder);
  const action = product => preordered(product) ? i18n["Pre-order"] : i18n["Buy now"];

  // Prices and buy links follow the add-on pick; the closing buy box and the sticky bar sell whichever set's page is open.
  function showOffer() {
    const p = selected(), sale = page(p) ? offer(p) : p;
    $('productPrice').textContent = money(sale.price);
    $('productCompare').hidden = !sale.comparePrice;
    $('productCompare').textContent = sale.comparePrice ? money(sale.comparePrice) : '';
    showSaving('productSave',sale);
    showBreakdown('productBreakdown',sale);
    // Where the second set goes: every board's two drawers hold a full set, the cover keeps the other on display.
    $('addOnNote').hidden = !(page(p) && addOnFor(p));
    $('productStoreLink').href = purchaseUrl(sale);
    $('productStoreLink').replaceChildren(dom.createTextNode(p.available ? (page(p) ? action(p) + ' · ' + money(sale.price) + ' ' : i18n["Shop this set "]) : i18n["Get notified "]), Object.assign(dom.createElement('span'), {textContent:'↗'}));
    // An out-of-stock set's page swaps its buy button for the restock sign-up, tagged with the set.
    const restock = page(p) && !p.available;
    $('restockForm').hidden = !restock;
    $('productStoreLink').hidden = restock;
    $('restockTags').value = 'restock,restock-' + p.id;
    const buy = page(p) ? sale : offer(products.find(product => product.id === 'modern'));
    $('buyBarName').textContent = buy.name;
    // Phones show the set's short name, with any added pieces on a line of their own: the full name does not fit there.
    const barSet = page(p) ? p : products.find(product => product.id === 'modern'), barAddOn = addOnFor(barSet);
    $('buyBarShortName').textContent = barSet.name + i18n[" set"];
    $('buyBarShortAddOn').textContent = barAddOn ? '+ ' + products.find(set => set.id === barAddOn.pieces).name + ' pieces' : '';
    $('buyBarShortAddOn').hidden = !barAddOn;
    $('modernFinalPrice').textContent = money(buy.price);
    $('modernFinalCompare').hidden = !buy.comparePrice;
    $('modernFinalCompare').textContent = buy.comparePrice ? money(buy.comparePrice) : '';
    showSaving('modernFinalSave',buy);
    showBreakdown('modernFinalBreakdown',buy);
    $('modernFinalStoreLink').href = purchaseUrl(buy);
    $('buyBarPrice').textContent = money(buy.price);
    $('buyBarCompare').hidden = !buy.comparePrice;
    $('buyBarCompare').textContent = buy.comparePrice ? money(buy.comparePrice) : '';
    $('buyBarLink').href = purchaseUrl(buy);
    // Their "Get notified" goes to that sign-up instead of leaving the page.
    $('buyBarLink').classList.toggle('is-restock',restock);
    $('modernFinalStoreLink').classList.toggle('is-restock',restock);
    $('buyBarLink').replaceChildren(dom.createTextNode(buy.available ? action(barSet) + ' ' : i18n["Get notified "]), Object.assign(dom.createElement('span'),{textContent:'↗'}));
    $('modernFinalStoreLink').replaceChildren(dom.createTextNode(buy.available ? action(barSet) + ' · ' + money(buy.price) + ' ' : i18n["Get notified "]), Object.assign(dom.createElement('span'),{textContent:'↗'}));
  }

  // The parts of the product page that differ between sets; everything else on it is shared.
  function pageDetails(p) {
    const info = p.page;
    $('modernProductInfo').setAttribute('aria-label',i18n["About the "] + p.name + i18n[" set"]);
    $('modernJump').setAttribute('aria-label',p.name + i18n[" set details"]);
    Object.entries(info.box).forEach(([part,photo]) => {
      const image = dom.querySelector('[data-box="' + part + '"]');
      image.src = photo.src; image.alt = photo.alt;
      image.classList.toggle('is-cutout', Boolean(photo.cutout));
    });
    $('boxPiecesTitle').textContent = info.box.pieces.title;
    $('productNote').textContent = info.note || ''; $('productNote').hidden = !info.note;
    // A set that was not on Kickstarter (AOT) leaves out the backer quotes, their shortcut and the Kickstarter mentions.
    detail.classList.toggle('is-unbacked', info.backed === false);
    // Pre-order sets swap the in-stock delivery promise for their shipping date and promise a refund if they can't ship.
    const ships = p.preorder ? 'from ' + p.preorder : null;
    $('perkShips').textContent = ships ? 'Ships ' + ships + ', in time for the holidays' : 'Ships within 2 business days';
    $('perkRefund').hidden = !ships;
    $('dispatchTime').textContent = ships ? 'From ' + p.preorder : 'Within 2 business days';
    $('modernDeliveryHeading').replaceChildren(...(ships ? ['Pre-order.', 'Ships ' + ships + '.'] : ['Ships within', '2 business days.'])
      .flatMap((line,i) => i ? [dom.createElement('br'), line] : [line]));
    // A set without measured heights (AOT) skips the piece table and the king's height.
    dom.querySelector('#modern-size .modern-size-table').hidden = !info.heights;
    $('kingClause').hidden = !info.heights;
    // The to-scale lineup uses each set's own cut-outs; a set without them keeps just the size table.
    $('pieceLineup').hidden = !info.scale;
    // Heights differ between sets; labels keep whichever unit the visitor picked.
    const unit = dom.querySelector('#modernProductInfo [data-unit][aria-pressed="true"]')?.dataset.unit || 'cm';
    if(info.scale) $('pieceLineup').querySelectorAll('[data-piece]').forEach(piece => {
      piece.querySelector('img').src = asset(info.scale + piece.dataset.piece + '.webp');
      const cm = info.heights[piece.dataset.piece], label = piece.querySelector('span');
      piece.style.setProperty('--cm', cm);
      label.dataset.cm = cm + ' cm'; label.dataset.in = Math.round(cm / 2.54 * 100) / 100 + ' in';
      label.textContent = label.dataset[unit];
    });
    if(info.heights) $('kingHeight').textContent = info.heights.king + ' cm';
    $('storyImage').src = info.story.src; $('storyImage').alt = info.story.alt;
    $('storyText').textContent = info.story.text;
    $('buyBarImage').src = p.image;
  }

  // The set alone (labelled with its name) or one of the other sets' pieces. The picker appears once a bundle is on sale; pieces that are
  // coming soon are listed beside it but cannot be picked.
  function addOnPicker(p) {
    const addOns = page(p) && p.available ? (p.addOns || []).filter(a => a.available || a.comingSoon) : [];
    $('addOnPicker').hidden = !addOns.some(a => a.available);
    if($('addOnPicker').hidden) return;
    const picked = addOnFor(p)?.pieces || '';
    $('addOnOptions').replaceChildren(...[null, ...addOns].map(addOn => {
      const pieces = addOn && products.find(set => set.id === addOn.pieces);
      const soon = Boolean(addOn && !addOn.available);
      const label = dom.createElement('label'); label.className = 'addon-option' + (soon ? ' is-soon' : '');
      const input = Object.assign(dom.createElement('input'), {type:'radio', name:'addOn', value:addOn ? addOn.pieces : '', disabled:soon});
      input.checked = input.value === picked;
      input.addEventListener('change', () => {addOnChoice[p.id] = input.value; showOffer();}, {signal:eventSignal});
      const thumb = Object.assign(dom.createElement('img'), {src:addOn ? addOn.image : p.setCutout, alt:'', width:80, height:55, loading:'lazy', decoding:'async'});
      thumb.className = 'addon-option-thumb';
      const text = dom.createElement('span'); text.className = 'addon-option-text';
      text.append(Object.assign(dom.createElement('strong'), {textContent:addOn ? '+ ' + pieces.name + ' pieces' : p.name + i18n[" set"]}),
        Object.assign(dom.createElement('small'), {textContent:soon ? 'Coming soon with the ' + pieces.name + i18n[" set"] : addOn ? (pieces.preorder ? 'Pre-order · ships from ' + pieces.preorder : 'Swap styles on the same board · 32 pieces') : 'Board, 32 pieces and cover'}));
      // The set-alone option has no extra price; in its place it shows what the add-ons leave out: the board and cover.
      const price = addOn ? Object.assign(dom.createElement('span'), {className:'addon-option-price', textContent:'+' + money(addOn.price)})
        : Object.assign(dom.createElement('img'), {className:'addon-option-board', src:asset('assets/board-cover-thumb.webp'), alt:'', width:76, height:32, loading:'lazy', decoding:'async'});
      label.append(input, thumb, text, price);
      return label;
    }));
  }

  function updateCards() {
    products.forEach(p => {
      $('cardPrice-' + p.id).textContent = money(p.price);
      const compare = $('cardCompare-' + p.id);
      compare.hidden = !p.comparePrice || p.comparePrice <= p.price;
      compare.textContent = p.comparePrice ? money(p.comparePrice) : '';
      $('cardStatus-' + p.id).textContent = p.available ? (p.preorder ? i18n["Pre-order"] : i18n["In stock"]) : i18n["Sold out"];
    });
  }
  function openOverview() {
    detail.hidden = true; overview.hidden = false;
    $('shopPanel').setAttribute('aria-labelledby','shopHeading');
    if(!$('shopPanel').hidden) history.replaceState(null,'','#catalog');
    dom.title = runtime.MasteekHomeTitle;
    runtime.MasteekCollections?.showCatalog(null);
    clearTimeout(timer); dragging = null; touching = false;
    carousel.classList.remove('is-dragging');
  }

  function photoDetails() {
    const images = photos();
    lights = source().light;
    $('productCounter').textContent = String(photoIndex + 1).padStart(2,'0') + ' / ' + String(images.length).padStart(2,'0') + i18n[" · Lights "] + lights;
    photoButtons.forEach((button,index) => button.setAttribute('aria-pressed',String(index === photoIndex)));
    dom.querySelectorAll('[data-light]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.light === lights)));
    $('productPrev').hidden = $('productNext').hidden = images.length < 2;
  }

  function nearest() {
    return slides.reduce((best, s) => !best || Math.abs(target(s) - carousel.scrollLeft) < Math.abs(target(best) - carousel.scrollLeft) ? s : best, null);
  }
  function update() {
    if(!slot) return;
    slides.forEach(s => {
      const distance = Math.abs((target(s) - carousel.scrollLeft) / slot);
      if(flat()) {
        // Neighbouring photos fade while sliding, which reads as a crossfade.
        s.image.style.transform = '';
        s.image.style.opacity = String(Math.max(0, 1 - .65 * Math.min(distance, 1)));
      } else {
        s.image.style.transform = 'scale(' + (1 - .24 * Math.min(distance, 1)) + ')';
        s.image.style.opacity = String(Math.max(0, (1 - .5 * Math.min(distance, 1)) * (1 - Math.max(distance - 1, 0))));
      }
      s.button.style.zIndex = String(100 - Math.round(distance * 10));
    });
    const n = nearest();
    if(n && n.photoIndex !== photoIndex) {photoIndex = n.photoIndex; photoDetails();}
  }
  function scroll(s, smooth = true) {
    if(!s) return;
    carousel.scrollTo({left:target(s), behavior:smooth && !reduced() ? 'smooth' : 'instant'});
    if(!smooth || reduced()) update();
  }
  function choose(id,scrollToStart = true) {
    if(!products.some(p => p.id === id)) return;
    overview.hidden = true; detail.hidden = false;
    $('shopPanel').setAttribute('aria-labelledby','productName');
    selectedId = id; lights = 'on'; photoIndex = 0;
    const p = selected();
    history.replaceState(null,'',page(p) ? p.page.hash : '#catalog');
    dom.title = page(p) ? p.subtitle + i18n[" | MASTEEK"] : runtime.MasteekHomeTitle;
    buildSlides(); details(); layout();
    runtime.MasteekCollections?.showCatalog(id);
    if(scrollToStart) {
      $('backToCollections').focus({preventScroll:true});
      detail.scrollIntoView({behavior:reduced() ? 'instant' : 'smooth', block:'start'});
    }
  }
  function layout() {
    if(!carousel.clientWidth || $('shopPanel').hidden || detail.hidden) return;
    slot = carousel.clientWidth * (flat() ? 1 : .54);
    carousel.style.setProperty('--product-image-width', carousel.clientWidth * (flat() ? 1 : .72) + 'px');
    $('productTrack').style.paddingLeft = (carousel.clientWidth - slot) / 2 + 'px';
    $('productTrack').style.paddingRight = (carousel.clientWidth - slot) / 2 + 'px';
    slides.forEach(s => {s.button.style.width = slot + 'px';});
    scroll(slides.find(s => s.photoIndex === photoIndex && !s.clone), false);
  }
  function settle() {
    if(dragging || touching || detail.hidden || $('shopPanel').hidden) return;
    const n = nearest();
    if(!n) return;
    if(Math.abs(target(n)-carousel.scrollLeft)>2) {scroll(n); return;}
    if(n.clone) scroll(slides.find(s => s.photoIndex === n.photoIndex && !s.clone), false);
  }
  function move(delta) {
    if(photos().length < 2) return;
    const n = nearest();
    const adjacent = slides[(n?.index ?? 1) + delta];
    if(adjacent) {scroll(adjacent); return;}
    const original = slides.find(s => s.photoIndex === photoIndex && !s.clone);
    scroll(original, false);
    scroll(slides[original.index + delta]);
  }
  function zoom() {
    const p = selected();
    $('productZoomImage').src = source().src;
    $('productZoomImage').alt = source().alt || p.subtitle + i18n[" with lights "] + lights;
    $('productZoomName').textContent = p.subtitle;
    runtime.MasteekDialogs.open($('productZoomDialog'));
  }

  async function refreshProducts() {
    if(typeof fetch !== 'function') return;
    try {
      const response = await fetch('/products.json', {signal:AbortSignal.timeout(8000)});
      if(!response.ok) return;
      const data = await response.json();
      if(!Array.isArray(data.products)) return;
      products.forEach(p => {
        const live = data.products.find(item => item.handle === p.handle);
        if(!live || !Array.isArray(live.variants) || !live.variants.length) return;
        const v = live.variants.find(item => item.available) || live.variants[0];
        const price = Number(v.price), compare = v.compare_at_price ? Number(v.compare_at_price) : null;
        if(!p.priceLocked && Number.isFinite(price) && price > 0) p.price = price;
        if(!p.priceLocked) p.comparePrice = Number.isFinite(compare) && compare > p.price ? compare : null;
        // A pre-order set stays on sale while Shopify still counts it as out of stock.
        p.available = live.variants.some(item => item.available === true) || Boolean(p.preorder);
        if(page(p) && /^\d+$/.test(String(v.id))) p.checkoutUrl = cartUrl(v.id);
      });
      // A bundle shows up here once it is on sale; until then its option keeps the built-in details.
      products.forEach(p => (p.addOns || []).forEach(addOn => {
        const v = data.products.find(item => item.handle === addOn.handle)?.variants?.[0];
        if(!v) return;
        addOn.available = v.available === true;
        if(Number(v.price) > p.price) addOn.price = Number(v.price) - p.price;
        if(/^\d+$/.test(String(v.id))) addOn.checkoutUrl = cartUrl(v.id);
      }));
      details();
    } catch { /* Store links remain usable if a refresh is unavailable. */ }
  }

  function buildSlides() {
    const product = selected(), images = photos();
    const originals = images.map((photo,photoIndex) => ({photo,photoIndex}));
    const entries = images.length > 1 ? [originals.at(-1), ...originals, originals[0]] : originals;
    slides = entries.map(({photo,photoIndex},index) => {
      const button = dom.createElement('button');
      button.type = 'button'; button.className = 'product-slide';
      button.setAttribute('aria-label', photo.alt || product.subtitle + i18n[" with lights "] + photo.light);
      const image = dom.createElement('img');
      // On a product page the first photo is the largest paint, so it goes first; photos further along wait until they are near.
      if(flat()) {if(index === 1) image.fetchPriority = 'high'; else if(index > 2 && index < entries.length - 1) image.loading = 'lazy';}
      image.src = photo.src; image.alt = photo.alt || product.subtitle + i18n[" with lights "] + photo.light; image.draggable = false; image.decoding = 'async';
      const clone = images.length > 1 && (index === 0 || index === entries.length - 1);
      if(clone) {button.setAttribute('aria-hidden','true'); button.tabIndex = -1;}
      const s = {photo,photoIndex,button,image,index,clone};
      button.append(image);
      button.addEventListener('click', () => {
        if(performance.now() < suppressClickUntil) return;
        if(Math.abs(target(s)-carousel.scrollLeft)<slot*.12) zoom(); else scroll(s);
      }, {signal:eventSignal});
      button.addEventListener('focus', () => {if(!dragging) scroll(s);}, {signal:eventSignal});
      return s;
    });
    $('productTrack').replaceChildren(...slides.map(s => s.button));
    photoButtons = images.map((photo,index) => {
      const button = dom.createElement('button'); button.type = 'button'; button.className = 'product-thumb';
      button.setAttribute('aria-label',i18n["View product photo "] + (index+1));
      const image = dom.createElement('img'); image.src = photo.src; image.alt = ''; image.loading = 'lazy'; image.decoding = 'async';
      button.append(image); button.addEventListener('click',() => {
        const s = slides.find(s => s.photoIndex === index && !s.clone);
        if(s.photoIndex === photoIndex) return;
        scroll(s,false);
        if(flat() && !reduced()) s.image.animate([{opacity:.3},{opacity:1}],{duration:420,easing:'cubic-bezier(0.16,1,0.3,1)'});
      }, {signal:eventSignal});
      return button;
    });
    $('productThumbnails').replaceChildren(...photoButtons); $('productThumbnails').hidden = !page(product);
  }
  Object.entries(homeOffers).forEach(([id,prefix]) => $(prefix + 'StoreLink').addEventListener('click',event => {event.preventDefault();runtime.showChessPanel('shop');choose(id);}, {signal:eventSignal}));
  dom.querySelectorAll('[data-product]').forEach(b => b.addEventListener('click', () => choose(b.dataset.product), {signal:eventSignal}));
  $('backToCollections').addEventListener('click', () => {
    openOverview();
    overview.scrollIntoView({behavior:reduced() ? 'instant' : 'smooth', block:'start'});
    dom.querySelector('[data-product="' + selectedId + '"]').focus({preventScroll:true});
  }, {signal:eventSignal});
  dom.querySelectorAll('[data-light]').forEach(b => b.addEventListener('click', () => {
    const candidates = slides.filter(s => s.photo.light === b.dataset.light);
    scroll(candidates.reduce((best,s) => !best || Math.abs(target(s)-carousel.scrollLeft) < Math.abs(target(best)-carousel.scrollLeft) ? s : best, null));
  }, {signal:eventSignal}));
  $('productPrev').addEventListener('click', () => move(-1), {signal:eventSignal});
  $('productNext').addEventListener('click', () => move(1), {signal:eventSignal});
  $('productZoom').addEventListener('click', zoom, {signal:eventSignal});
  $('meetCharacters').addEventListener('click', () => {
    $('galleryPanel').scrollIntoView({behavior:reduced() ? 'instant' : 'smooth', block:'start'});
  }, {signal:eventSignal});
  // Kickstarter proof in the buy box: jump to the owner quotes (or the specs, if there are no quotes yet).
  ['modernFinalStoreLink','buyBarLink'].forEach(id => $(id).addEventListener('click', event => {
    if(!$(id).classList.contains('is-restock')) return;
    event.preventDefault();
    $('restockForm').scrollIntoView({block:'center', behavior:reduced() ? 'instant' : 'smooth'});
    $('restockEmail').focus({preventScroll:true});
  }, {signal:eventSignal}));
  // The restock sign-up reaches Shopify only on the store itself; previews say so instead of sending anything.
  const restockStatus = text => {$('restockStatus').textContent = text;};
  // Shopify's spam check (hCaptcha) binds to the form when it is first focused: it takes over the form's submit, adds
  // its token, then calls the form's own submit(). Setting that to this sender before it binds keeps the sign-up in
  // the page with the token included, instead of a full reload.
  const restockForm = $('restockForm');
  const sendRestock = async () => {
    const form = restockForm, button = form.querySelector('button');
    button.disabled = true;
    try {
      const response = await fetch(form.action, {method:'POST', body:new FormData(form)});
      if(response.url.includes('/challenge')) {
        // Shopify wants a human check: open its check page (re-sending would reuse the spent token, which it refuses),
        // and thank the visitor when the store sends them back.
        try {sessionStorage.setItem('masteek-restock', selected().id);} catch { /* They land on Home instead. */ }
        location.assign(response.url);
        return;
      }
      if(!response.url.includes('customer_posted=true')) throw new Error('not posted');
      form.reset();
      restockStatus("Thanks! We'll email you when it's back in stock.");
    } catch {
      restockStatus("Couldn't sign you up just now. Please try again.");
    } finally {
      button.disabled = false;
    }
  };
  restockForm.submit = sendRestock;
  restockForm.addEventListener('submit', event => {
    event.preventDefault();
    if(!/(^|\.)masteek\.com$|\.myshopify\.com$/.test(location.hostname)) {restockStatus('Sign-up works on masteek.com; this preview sends nothing.'); return;}
    // Once the spam check is bound, its own submit listener gets the token and then calls sendRestock.
    if(!restockForm.hasAttribute('data-hcaptcha-bound')) sendRestock();
  }, {signal:eventSignal});
  if(runtime.MasteekRestockThanks) restockStatus("Thanks! We'll email you when it's back in stock.");
  $('modernBacked').addEventListener('click', () => {
    const quotes = $('modern-reviews');
    (quotes.hidden ? $('modern-size') : quotes).scrollIntoView({behavior:reduced() ? 'instant' : 'smooth', block:'start'});
    if(!quotes.hidden) $('quoteTrack').focus({preventScroll:true});
  }, {signal:eventSignal});
  carousel.addEventListener('scroll', () => {
    if(!frame) frame = requestAnimationFrame(() => {frame=0; update();});
    clearTimeout(timer); timer = setTimeout(settle, 180);
  }, eventOptions({passive:true}));
  carousel.addEventListener('touchstart', () => {touching=true;}, eventOptions({passive:true}));
  function endTouch() {touching=false; clearTimeout(timer); timer=setTimeout(settle,180);}
  carousel.addEventListener('touchend',endTouch, eventOptions({passive:true}));
  carousel.addEventListener('touchcancel',endTouch, eventOptions({passive:true}));
  carousel.addEventListener('pointerdown', e => {
    if(e.pointerType !== 'mouse' || e.button !== 0) return;
    dragging = {x:e.clientX, scroll:carousel.scrollLeft, pointer:e.pointerId, moved:false};
  }, {signal:eventSignal});
  carousel.addEventListener('pointermove', e => {
    if(!dragging) return;
    const delta = e.clientX - dragging.x;
    if(Math.abs(delta)>5) {dragging.moved=true; carousel.classList.add('is-dragging'); carousel.setPointerCapture(e.pointerId);}
    if(dragging.moved) {e.preventDefault(); carousel.scrollLeft=dragging.scroll-delta; update();}
  }, {signal:eventSignal});
  function endDrag() {
    if(!dragging) return;
    const {moved,pointer} = dragging; dragging=null;
    if(carousel.hasPointerCapture(pointer)) carousel.releasePointerCapture(pointer);
    carousel.classList.remove('is-dragging');
    if(moved) {suppressClickUntil=performance.now()+300; scroll(nearest());}
  }
  carousel.addEventListener('pointerup',endDrag, {signal:eventSignal}); carousel.addEventListener('pointercancel',endDrag, {signal:eventSignal});
  carousel.addEventListener('pointerleave', () => {if(dragging && !dragging.moved) dragging=null;}, {signal:eventSignal});
  dom.addEventListener('keydown',e => {
    if(e.defaultPrevented || e.target?.closest?.('.modern-gallery') || $('zoomDialog').open || !$('galleryPanel').hidden) return;
    if($('shopPanel').hidden || detail.hidden || $('productZoomDialog').open) return;
    if(e.key==='ArrowLeft') {e.preventDefault(); move(-1);}
    if(e.key==='ArrowRight') {e.preventDefault(); move(1);}
  });
  // The pieces' closer look: the gallery that opens it passes its set and how to step to the next piece, so the
  // window can browse with arrows, swipes and arrow keys, and end on a way to buy that set.
  let zoomControl = null;
  function zoomShop() {
    const p = products.find(product => product.id === zoomControl?.set);
    if(!p) {$('zoomShop').hidden = true; return;}
    $('zoomShop').hidden = false;
    $('zoomShop').href = p.page.hash;
    const verb = !p.available ? 'View the ' : p.preorder ? 'Pre-order the ' : 'Shop the ';
    $('zoomShop').replaceChildren(dom.createTextNode(verb + p.name + i18n[" set"] + (p.available ? ' · ' + money(p.price) : '') + ' '), Object.assign(dom.createElement('span'), {textContent:'→', ariaHidden:'true'}));
  }
  runtime.MasteekZoomShow = control => {
    zoomControl = control;
    zoomShop();
    runtime.MasteekDialogs.open($('zoomDialog'));
  };
  const zoomStep = delta => {if($('zoomDialog').open) zoomControl?.step(delta);};
  $('zoomPrev').addEventListener('click', () => zoomStep(-1), {signal:eventSignal});
  $('zoomNext').addEventListener('click', () => zoomStep(1), {signal:eventSignal});
  $('zoomDialog').addEventListener('keydown', event => {
    if(event.key === 'ArrowLeft' || event.key === 'ArrowRight') {event.preventDefault(); zoomStep(event.key === 'ArrowLeft' ? -1 : 1);}
  }, {signal:eventSignal});
  let swipe = null;
  $('zoomArt').addEventListener('pointerdown', event => {swipe = {x:event.clientX, y:event.clientY};}, {signal:eventSignal});
  $('zoomArt').addEventListener('pointerup', event => {
    if(!swipe) return;
    const dx = event.clientX - swipe.x, dy = event.clientY - swipe.y;
    swipe = null;
    if(Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) zoomStep(dx < 0 ? 1 : -1);
  }, {signal:eventSignal});
  $('zoomArt').addEventListener('pointercancel', () => {swipe = null;}, {signal:eventSignal});
  // The buy button closes the window, then jumps straight to that set's buy box (price, add-ons, buy button), from Home or
  // from the set's own page alike.
  $('zoomShop').addEventListener('click', event => {
    event.preventDefault();
    const id = zoomControl?.set;
    if(!id) return;
    // Close the "All pieces" list too when the piece was opened from it.
    $('zoomDialog').close();
    if($('catalogDialog').open) $('catalogDialog').close();
    // The window puts the page back where it was over the next frames; move on after that.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      runtime.showChessPanel('shop');
      if(selectedId !== id || detail.hidden) choose(id,false);
      requestAnimationFrame(() => $('productPrice').closest('.product-price').scrollIntoView({behavior:'instant', block:'start'}));
    }));
  }, {signal:eventSignal});

  runtime.MasteekCatalog = {layout, refreshProducts, openOverview, choose};
  window.addEventListener('hashchange',() => {
    const p = products.find(product => product.page?.hash === location.hash || product.aliases?.includes(location.hash));
    if(p) {runtime.showChessPanel('shop');choose(p.id);}
  }, {signal:eventSignal});
  new ResizeObserver(layout).observe(carousel);
  buildSlides(); details(); layout(); refreshProducts();
})();

// ---- modern-gallery.js
(() => {
  const $ = id => dom.getElementById(id);
  // Every piece photo comes in two sizes: full for the closer look, and a 648 px wide copy for the slideshow, which never
  // shows a piece wider than about 320 px. The sets below list each photo without its size and extension.
  const file = (photo,size) => asset(photo + (size === 'small' ? '-648' : '') + '.webp');
  const models = {
    white: {Pawn:['170708'],Rook:['170745'],Knight:['170924'],Bishop:['170807'],Queen:['171034','171120'],King:['171206']},
    red: {Pawn:['171309'],Rook:['171409'],Knight:['171447'],Bishop:['171543','171636'],Queen:['171723'],King:['171818']}
  };
  const roles = ['Pawn','Rook','Knight','Bishop','Queen','King'];
  // Each set has its own slideshow, shown on Home and on that set's page. Its elements share the set's id prefix.
  const sets = {
    modern: {name:'Modern', images:(team,role) => models[team][role].map(stamp => 'assets/modern/IMG20261015' + stamp)},
    original: {name:'Original', images:(team,role) => ['assets/original/' + team + '-' + role.toLowerCase()]}
  };
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slideshow(set) {
    const section = $(set + 'Gallery'), stage = $(set + 'Stage'), carousel = $(set + 'Carousel'), track = $(set + 'Track'), rail = $(set + 'Rail');
    const name = sets[set].name;
    let side = 'white', index = 0, slides = [], cells = [], slot = 0, frame = 0, timer = 0;
    let dragging = null, touching = false, suppressClickUntil = 0;
    const label = (s = side) => s === 'white' ? i18n["White"] : i18n["Red"];
    const otherSide = () => side === 'white' ? 'red' : 'white';
    const images = (i,size,s = side) => sets[set].images(s,roles[i]).map(photo => file(photo,size));
    const primary = (i,size,s = side) => images(i,size,s)[0];
    const artworkClass = (i,s = side) => 'figure-art photo cutout' + (set === 'modern' && s === 'white' && roles[i] === 'Knight' ? ' modern-white-knight' : '');
    const target = s => s.button.offsetLeft + slot / 2 - carousel.clientWidth / 2;
    const active = () => !section.hidden;

    function details() {
      window.dispatchEvent(new CustomEvent('masteek:piece-view', {detail:set + ':' + side + ':' + index}));
      $(set + 'PieceName').textContent = roles[index];
      $(set + 'PieceSide').textContent = label();
      $(set + 'PieceCount').textContent = (index + 1) + ' / ' + roles.length;
      cells.forEach((cell,i) => cell.setAttribute('aria-pressed',String(i === index)));
    }
    function nearest() {
      return slides.reduce((best,s) => !best || Math.abs(target(s)-carousel.scrollLeft) < Math.abs(target(best)-carousel.scrollLeft) ? s : best,null);
    }
    function update() {
      if(!slot || !active()) return;
      slides.forEach(s => {
        const distance = Math.abs((target(s)-carousel.scrollLeft)/slot), depth = Math.min(distance,1);
        s.art.style.transform = 'scale(' + (1 - .38*depth - .06*Math.min(Math.max(distance-1,0),1)) + ')';
        s.art.style.opacity = String(Math.max(0,(1-.36*depth)*(1-2*Math.max(distance-1,0))));
        s.art.style.setProperty('--depth-blur',(reduced() ? 0 : Math.min(distance,2)*.7) + 'px');
        // The centred piece glows like a lit piece on the board; the glow fades as it moves aside.
        s.art.style.setProperty('--lit',(Math.max(0,1 - distance*2.5)*.6).toFixed(3));
        s.button.style.zIndex = String(100-Math.round(distance*10));
      });
      // Rail marker: the centred position among the six pieces, following the row continuously.
      const first = slides.find(s => s.position === 2);
      let at = (carousel.scrollLeft - target(first)) / slot;
      at = ((at % roles.length) + roles.length) % roles.length;
      if(at > roles.length - 1) at = at - (roles.length - 1) < .5 ? roles.length - 1 : 0;
      rail.style.setProperty('--rail', (at / (roles.length - 1)).toFixed(4));
      const current = nearest();
      // The other colour's pieces at the ends take over only once the row settles on one (settle).
      if(current && current.side === side && current.pieceIndex !== index) {index = current.pieceIndex; details();}
    }
    function scroll(slide,smooth = true) {
      if(!slide) return;
      carousel.scrollTo({left:target(slide),behavior:smooth && !reduced() ? 'smooth' : 'instant'});
      if(!smooth || reduced()) update();
    }
    function select(i) {
      const candidates = slides.filter(s => s.pieceIndex === i);
      scroll(candidates.reduce((best,s) => !best || Math.abs(target(s)-carousel.scrollLeft)<Math.abs(target(best)-carousel.scrollLeft) ? s : best,null));
    }
    function move(delta) {
      const current = nearest();
      const next = slides[(current?.position ?? index + 2) + delta];
      if(next) scroll(next); else select((index + delta + roles.length) % roles.length);
    }
    function layout() {
      if(!active() || !carousel.clientWidth) return;
      slot = carousel.clientWidth * .32;
      // Set on the stage so the row height and the arrows can follow the piece size too (carousel.css).
      stage.style.setProperty('--figure-width',carousel.clientWidth * (window.matchMedia('(max-width:700px)').matches ? .60 : .50) + 'px');
      const padding = (carousel.clientWidth-slot)/2 + 'px';
      track.style.paddingLeft = padding; track.style.paddingRight = padding;
      slides.forEach(s => {s.button.style.width = slot + 'px';});
      scroll(slides.find(s => s.pieceIndex === index && !s.clone),false);
    }
    function settle() {
      if(!active() || dragging || touching) return;
      const current = nearest();
      if(!current) return;
      if(Math.abs(target(current)-carousel.scrollLeft)>2) {scroll(current);return;}
      if(current.clone) setSide(current.side, current.pieceIndex);
    }
    function zoom() {
      const picture = dom.createElement('span'); picture.className = artworkClass(index); picture.style.aspectRatio = '3 / 4';
      const img = dom.createElement('img'); img.src = primary(index); img.alt = label() + ' ' + name + ' ' + roles[index]; picture.append(img);
      $('zoomArt').replaceChildren(picture);
      $('zoomName').textContent = roles[index]; $('zoomRole').textContent = label() + ' · ' + name + ' · ' + (index + 1) + i18n[" of "] + roles.length;
      $('zoomDescription').textContent = ''; $('zoomDescription').hidden = true;
      const photos = images(index);
      $('zoomPhotos').hidden = photos.length < 2;
      $('zoomPhotos').replaceChildren(...photos.map((src,i) => {
        const button = dom.createElement('button'); button.type = 'button'; button.textContent = String(i+1);
        button.setAttribute('aria-label',i18n["View angle "] + (i+1)); button.setAttribute('aria-pressed',String(src === img.src || src === primary(index)));
        button.addEventListener('click',() => {img.src = src; [...$('zoomPhotos').children].forEach((b,j) => b.setAttribute('aria-pressed',String(i === j)));}, {signal:eventSignal});
        return button;
      }));
      runtime.MasteekZoomShow({set, step:delta => {
        // The slideshow catches up as it scrolls; the window shows the new piece straight away.
        index = (index + delta + roles.length) % roles.length;
        select(index); zoom();
      }});
    }
    function build() {
      clearTimeout(timer);
      cells = roles.map((role,i) => {
        const button = dom.createElement('button'); button.type = 'button'; button.className = 'board-cell' + ((i + (side === 'red' ? 0 : 1)) % 2 ? ' dark' : '') + (side === 'red' ? ' titan' : '');
        button.dataset.pieceIndex = String(i); button.setAttribute('aria-label',label() + ' ' + role);
        const icon = dom.createElement('span'); icon.className = 'chess-icon'; icon.innerHTML = runtime.MasteekChessArt(side !== 'red', role); icon.setAttribute('aria-hidden','true');button.append(icon);
        button.addEventListener('click',() => select(i), {signal:eventSignal}); return button;
      });
      $(set + 'SelectionBoard').replaceChildren(...cells);
      // Past the last piece the row runs on into the other colour's first piece (and back from the first).
      const other = otherSide();
      const order = [[other,roles.length-2],[other,roles.length-1],...roles.map((_,i) => [side,i]),[other,0],[other,1]];
      slides = order.map(([pieceSide,pieceIndex],position) => {
        const button = dom.createElement('button'); button.type = 'button'; button.className = 'carousel-slide';
        button.setAttribute('aria-label',i18n["Select "] + label(pieceSide) + ' ' + roles[pieceIndex]);
        const art = dom.createElement('span'); art.className = artworkClass(pieceIndex,pieceSide);
        const img = dom.createElement('img'); img.src = primary(pieceIndex,'small',pieceSide); img.alt = label(pieceSide) + ' ' + name + ' ' + roles[pieceIndex]; img.draggable = false; img.decoding = 'async'; art.append(img);button.append(art);
        const clone = position < 2 || position >= roles.length + 2;
        if(clone) {button.setAttribute('aria-hidden','true');button.tabIndex = -1;}
        const slide = {button,art,pieceIndex,position,clone,side:pieceSide};
        // A side piece comes to the centre when clicked; the centred one stays put.
        button.addEventListener('click',() => {if(performance.now()<suppressClickUntil) return; if(Math.abs(target(slide)-carousel.scrollLeft)>=slot*.12) scroll(slide);}, {signal:eventSignal});
        button.addEventListener('focus',() => {if(!dragging) scroll(slide);}, {signal:eventSignal});
        return slide;
      });
      track.replaceChildren(...slides.map(s => s.button));details();layout();
    }
    function setSide(next, pieceIndex = index) {
      if(side === next) return;
      side = next; index = pieceIndex; dragging = null; touching = false;
      section.querySelectorAll('[data-side]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.side === side)));
      build();
    }
    section.querySelectorAll('[data-side]').forEach(button => button.addEventListener('click',() => setSide(button.dataset.side), {signal:eventSignal}));
    section.querySelector('[data-swap]')?.addEventListener('click',() => setSide(otherSide()), {signal:eventSignal});
    $(set + 'Prev').addEventListener('click',() => move(-1), {signal:eventSignal});$(set + 'Next').addEventListener('click',() => move(1), {signal:eventSignal});
    section.addEventListener('keydown',e => {
      if(!active() || $('zoomDialog').open || e.altKey || e.ctrlKey || e.metaKey) return;
      if(e.key === 'ArrowLeft' || e.key === 'ArrowRight') {e.preventDefault();move(e.key === 'ArrowLeft' ? -1 : 1);}
    }, {signal:eventSignal});
    carousel.addEventListener('scroll',() => {
      if(!frame) frame = requestAnimationFrame(() => {frame=0;update();});
      clearTimeout(timer);timer = setTimeout(settle,180);
    }, eventOptions({passive:true}));
    carousel.addEventListener('touchstart',() => {touching=true;}, eventOptions({passive:true}));
    function endTouch() {touching=false;clearTimeout(timer);timer=setTimeout(settle,180);}
    carousel.addEventListener('touchend',endTouch, eventOptions({passive:true}));carousel.addEventListener('touchcancel',endTouch, eventOptions({passive:true}));
    carousel.addEventListener('pointerdown',e => {if(e.pointerType === 'mouse' && e.button === 0) dragging={x:e.clientX,scroll:carousel.scrollLeft,pointer:e.pointerId,moved:false};}, {signal:eventSignal});
    carousel.addEventListener('pointermove',e => {
      if(!dragging) return;
      const delta = e.clientX-dragging.x;
      if(Math.abs(delta)>5) {dragging.moved=true;carousel.classList.add('is-dragging');carousel.setPointerCapture(e.pointerId);}
      if(dragging.moved) {e.preventDefault();carousel.scrollLeft=dragging.scroll-delta;update();}
    }, {signal:eventSignal});
    function endDrag() {
      if(!dragging) return;
      const {moved,pointer} = dragging;dragging=null;
      if(carousel.hasPointerCapture(pointer)) carousel.releasePointerCapture(pointer);
      carousel.classList.remove('is-dragging');
      if(moved) {suppressClickUntil=performance.now()+300;scroll(nearest());}
    }
    carousel.addEventListener('pointerup',endDrag, {signal:eventSignal});carousel.addEventListener('pointercancel',endDrag, {signal:eventSignal});
    carousel.addEventListener('pointerleave',() => {if(dragging && !dragging.moved) dragging=null;}, {signal:eventSignal});
    // The first time the slideshow is in view, slide the row a little way and back so it reads as swipeable.
    // Runs once, never under reduced motion, and stops as soon as the visitor touches the row.
    let nudged = false, nudgeFrame = 0, nudgeStart = 0;
    function stopNudge() {
      nudged = true;
      if(!nudgeFrame) return;
      cancelAnimationFrame(nudgeFrame); nudgeFrame = 0;
      carousel.scrollLeft = nudgeStart; carousel.classList.remove('is-nudging'); update();
    }
    function nudge() {
      if(nudged || reduced() || !active() || !slot) return;
      nudged = true;
      nudgeStart = carousel.scrollLeft;
      const reach = slot * .45, began = performance.now(), length = 1300;
      carousel.classList.add('is-nudging');
      const step = now => {
        const t = Math.min(1, (now - began) / length);
        carousel.scrollLeft = nudgeStart + reach * Math.sin(Math.PI * t) ** 2;
        if(t < 1) nudgeFrame = requestAnimationFrame(step);
        else {nudgeFrame = 0; carousel.scrollLeft = nudgeStart; carousel.classList.remove('is-nudging'); update();}
      };
      nudgeFrame = requestAnimationFrame(step);
    }
    ['pointerdown','touchstart','wheel'].forEach(type => carousel.addEventListener(type, stopNudge, eventOptions({passive:true})));
    section.addEventListener('keydown', stopNudge, {signal:eventSignal});
    if(typeof IntersectionObserver === 'function') {
      const seen = new IntersectionObserver(entries => {
        if(nudged) {seen.disconnect(); return;}
        if(entries.some(e => e.isIntersecting && e.intersectionRatio >= .6)) setTimeout(() => {nudge(); if(nudged) seen.disconnect();}, 350);
      }, {threshold:.6});
      seen.observe(stage);
    }
    new ResizeObserver(layout).observe(carousel);
    return {section, carousel, setVisible(visible) {
      section.hidden = !visible;
      if(visible) {if(!slides.length) build();else layout();}
      else {clearTimeout(timer);dragging=null;touching=false;carousel.classList.remove('is-dragging');}
    }};
  }
  runtime.MasteekSlideshows = Object.fromEntries(Object.keys(sets).map(set => [set, slideshow(set)]));
})();

// ---- collections.js
(() => {
  const $ = id => dom.getElementById(id);
  const aot = $('galleryPanel'), slideshows = runtime.MasteekSlideshows;
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Each set's slideshow sits above its offer on Home and moves onto the set's page in the Catalog.
  const home = {
    modern: {section:'homeModernSection', mount:'homeModernMount', explore:'homeExploreModern'},
    original: {section:'homeOriginalSection', mount:'homeOriginalMount', explore:'homeExploreOriginal'}
  };
  const place = (mount,node) => {if(node.parentElement !== $(mount)) $(mount).append(node);};

  function showHome() {
    place('homeAotMount',aot);
    aot.hidden = false;
    $('aot-offer').hidden = false;
    $('homeFeatures').hidden = false;
    Object.entries(home).forEach(([id,parts]) => {
      $(parts.section).hidden = false;
      place(parts.mount,slideshows[id].section);
      slideshows[id].setVisible(true);
    });
    runtime.MasteekAot.layout();
  }
  function showCatalog(product) {
    Object.values(home).forEach(parts => {$(parts.section).hidden = true;});
    $('homeFeatures').hidden = true;
    // On its page the AOT gallery takes the slideshow's place below the shortcuts; the page's buy box replaces its Home offer.
    aot.hidden = product !== 'aot';
    $('aot-offer').hidden = true;
    if(product === 'aot') {
      place('catalogModernMount',aot);
      runtime.MasteekAot.layout();
    }
    // A set's page shows its piece slideshow when the set has cut-out photos of each piece.
    const pieces = Boolean(runtime.MASTEEK_PRODUCTS.find(p => p.id === product)?.page?.pieceGallery);
    Object.entries(slideshows).forEach(([id,slideshow]) => {
      const shown = pieces && id === product;
      if(shown) place('catalogModernMount',slideshow.section);
      slideshow.setVisible(shown);
    });
  }
  Object.entries(home).forEach(([id,parts]) => $(parts.explore).addEventListener('click',() => {
    slideshows[id].section.scrollIntoView({behavior:reduced() ? 'instant' : 'smooth',block:'start'});
    slideshows[id].carousel.focus({preventScroll:true});
  }, {signal:eventSignal}));
  $('homeExploreAot').addEventListener('click',() => {
    aot.scrollIntoView({behavior:reduced() ? 'instant' : 'smooth',block:'start'});
  }, {signal:eventSignal});
  runtime.MasteekCollections = {showHome,showCatalog};
  // Only Home shows the hero; the Catalog and the puzzles page start with the Home sections closed.
  if(!$('videoHero').hidden) showHome();
  else showCatalog(null);
  if(runtime.MasteekInitialProduct) runtime.MasteekCatalog.choose(runtime.MasteekInitialProduct,false);
})();

// ---- header.js
// Site header (with the offer bar above it): on the way down it stays where it was and scrolls away with the page; on the
// way up it comes back in with the page and then stays stuck to the top. While a header link has keyboard focus it stays in view.
(() => {
  const header = dom.querySelector('.site-top') || dom.querySelector('.site-header');
  if (!header) return;
  const root = document.documentElement.style;
  let last = window.scrollY;
  let left = null; // the header's page position while it moves with the page; null while it is stuck to the top

  // Section jumps (--site-header-h) and the sticky product photos on desktop (--site-header-shown) leave room for it.
  function measure() {
    root.setProperty('--site-header-h', header.offsetHeight + 'px');
    root.setProperty('--site-header-shown', left === null ? header.offsetHeight + 'px' : '0px');
  }
  function stick() {
    left = null;
    header.style.position = header.style.top = '';
    measure();
  }
  // Leaves the header at page position y (never below its own place at the top), where it scrolls like other content.
  function leaveAt(y) {
    header.style.position = 'relative';
    header.style.top = '0px';
    const natural = header.getBoundingClientRect().top + window.scrollY;
    left = Math.max(y, natural);
    header.style.top = left - natural + 'px';
    measure();
  }

  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (left === null) {
      // It was stuck at the top of the screen at the last position, so it is left there.
      if (y > last && !header.querySelector(':focus-visible')) leaveAt(last);
    } else if (y <= left) {
      stick();
    } else if (y < last && left + header.offsetHeight < y) {
      // Scrolling up with the header out of sight: wait just above the screen, so it comes back in with the page.
      leaveAt(y - header.offsetHeight);
    }
    last = y;
  }, eventOptions({passive: true}));
  window.addEventListener('resize', measure, eventOptions({passive: true}));
  // Closing the offer bar, or the puzzles page hiding it, changes the height.
  if (typeof ResizeObserver === 'function') new ResizeObserver(measure).observe(header);
  header.addEventListener('focusin', () => {if (left !== null && header.querySelector(':focus-visible')) stick();}, {signal:eventSignal});
  measure();
})();

// Header cart count: on the store, ask Shopify how many items are in the cart; elsewhere the bag shows no number.
(() => {
  const count = dom.getElementById('cartCount');
  if(!count || !/(^|\.)masteek\.com$|\.myshopify\.com$/.test(location.hostname)) return;
  const update = () => fetch('/cart.js', {headers:{Accept:'application/json'}})
    .then(response => response.ok ? response.json() : null)
    .then(cart => {
      if(!cart) return;
      count.textContent = String(cart.item_count);
      count.hidden = !cart.item_count;
      count.parentElement.setAttribute('aria-label', cart.item_count ? 'Cart, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') : 'Cart');
    })
    .catch(() => {});
  update();
  // Coming back from checkout restores the page from memory: count again.
  window.addEventListener('pageshow', event => { if(event.persisted) update(); }, {signal:eventSignal});
})();

// ---- hero.js
(() => {
  const video = dom.getElementById('heroVideo');
  const toggle = dom.getElementById('heroVideoToggle');
  const hero = dom.getElementById('videoHero');
  if (!video || !toggle || !hero) return;

  video.muted = true;
  video.defaultMuted = true;
  let userPaused = false;
  const updateToggle = () => {
    // An icon button: the visible icon and the spoken name both follow the video.
    toggle.dataset.state = video.paused ? 'paused' : 'playing';
    toggle.setAttribute('aria-label', video.paused ? i18n["Play video"] : i18n["Pause video"]);
  };
  video.addEventListener('play', updateToggle, {signal:eventSignal});
  video.addEventListener('pause', updateToggle, {signal:eventSignal});
  toggle.addEventListener('click', () => {
    if (video.paused) {
      userPaused = false;
      video.play().catch(updateToggle);
    } else {
      userPaused = true;
      video.pause();
    }
  }, {signal:eventSignal});

  // The video has no autoplay and preload="none", so it only downloads once the hero is shown.
  // It plays while the hero is visible and pauses when another view hides it.
  const sync = () => {
    if (hero.hidden) {
      if (!video.paused) video.pause();
    } else if (!userPaused && video.paused) {
      video.play().catch(updateToggle);
    }
  };
  new MutationObserver(sync).observe(hero, {attributes: true, attributeFilter: ['hidden']});

  toggle.hidden = false;
  updateToggle();
  sync();
})();

// ---- features.js
// Home features band: the gaming clip plays only while it is on screen, and has a pause control.
(() => {
  const video = dom.getElementById('featureVideo');
  const toggle = dom.getElementById('featureVideoToggle');
  if (!video || !toggle) return;

  // With reduced motion the clip waits for the visitor to press play.
  let userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches, inView = false;
  const label = () => {
    // An icon button: the visible icon and the spoken name both follow the video.
    toggle.dataset.state = video.paused ? 'paused' : 'playing';
    toggle.setAttribute('aria-label', video.paused ? i18n["Play video"] : i18n["Pause video"]);
  };
  video.addEventListener('play', label, {signal:eventSignal});
  video.addEventListener('pause', label, {signal:eventSignal});
  toggle.addEventListener('click', () => {
    if (video.paused) {
      userPaused = false;
      video.play().catch(label);
    } else {
      userPaused = true;
      video.pause();
    }
  }, {signal:eventSignal});

  const sync = () => {
    if (inView && !userPaused) video.play().catch(label);
    else if (!video.paused) video.pause();
  };
  if (typeof IntersectionObserver === 'function') {
    new IntersectionObserver(entries => {
      inView = entries.some(entry => entry.isIntersecting);
      sync();
    }, {threshold: .4}).observe(video);
  }
  label();
})();

// ---- testimonials.js
// Owner quotes for the Modern page. Real customers only, quoted word for word (shorten with …, never reword),
// and only with their OK. The section stays hidden while this list is empty.
// Fields: quote (text without quotation marks), name (first name and initial), detail (optional, e.g. country).
// The source is shown once, in the "Backed on Kickstarter" badge above the quotes, so captions are name-only.
// Sources: Ben L. is a public Kickstarter comment; the others are backers' messages, confirmed by Masteek as
// their own words and shared with their permission.
runtime.MASTEEK_TESTIMONIALS = [
  {
    quote: 'Honestly, the quality exceeded my expectations. The details on the pieces are incredible, and the lighting makes the entire board look stunning.',
    name: 'M.K.'
  },
  {
    quote: 'Seeing the pieces light up for the first time was such a cool experience.',
    name: 'A.T.'
  },
  {
    quote: 'Pictures don’t do this board justice. It looks absolutely amazing in person!',
    name: 'D.S.'
  },
  {
    quote: 'You can tell a lot of work went into this. It feels like a premium collector’s piece rather than an ordinary chess set.',
    name: 'J.R.'
  },
  {
    quote: 'The way the pieces glow is just beautiful. It’s easily the coolest chess set I’ve ever owned.',
    name: 'L.M.'
  },
  {
    quote: 'I’ve just received my board and I am absolutely blown away. The build quality is absolutely fantastic… The wait was absolutely worth it.',
    name: 'Ben L.'
  }
];

// ---- testimonial-slider.js
// Owner quotes on the Modern and Original pages, shown as chat messages: swipe or arrows, with the same scroll rail as
// the piece slideshows. They also move on by one message every few seconds, looping without rewinding. Autoplay never
// runs under reduced motion, pauses while the row is hovered, keyboard-focused, off screen or in a background tab, and
// has a pause button whose ring shows the time to the next message.
(() => {
  const list = runtime.MASTEEK_TESTIMONIALS || [];
  const section = dom.getElementById('modern-reviews');
  if (!section || !list.length) return;
  const track = dom.getElementById('quoteTrack'), rail = dom.getElementById('quoteRail');
  const controls = section.querySelector('.quote-controls'), toggle = dom.getElementById('quoteToggle');
  const ring = toggle.querySelector('.quote-ring-progress');
  const n = list.length;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reduced = () => motion.matches;
  const initials = name => name.split(/[\s.]+/).filter(Boolean).map(w => w[0]).join('').slice(0, 2).toUpperCase();

  const message = (item, i, copy) => {
    const figure = dom.createElement('figure');
    figure.className = 'quote';
    figure.setAttribute('role', 'group');
    figure.setAttribute('aria-roledescription', 'slide');
    figure.setAttribute('aria-label', (i + 1) + i18n[" of "] + n);
    if (copy) {figure.setAttribute('aria-hidden', 'true'); figure.inert = true;}
    const caption = dom.createElement('figcaption');
    const name = dom.createElement('strong');
    name.textContent = item.name;
    // Every quote here is from a Kickstarter backer (see testimonials.js), so each name carries the green Backer tag.
    const backer = dom.createElement('span');
    backer.className = 'quote-backer';
    backer.textContent = i18n["Backer"];
    caption.append(name, ' ', backer);
    if (item.detail) {
      const detail = dom.createElement('span');
      detail.textContent = item.detail;
      caption.append(' ', detail);
    }
    const quote = dom.createElement('blockquote');
    const text = dom.createElement('p');
    text.textContent = item.quote;
    quote.append(text);
    const avatar = dom.createElement('span');
    avatar.className = 'quote-avatar';
    avatar.setAttribute('aria-hidden', 'true');
    avatar.textContent = initials(item.name);
    figure.append(caption, quote, avatar);
    return figure;
  };
  // The messages are drawn twice so the row can keep moving forward: past the last one it carries on into the copies
  // of the first ones, then jumps back to the originals, which look exactly the same.
  track.replaceChildren(...list.map((item, i) => message(item, i, false)), ...list.map((item, i) => message(item, i, true)));
  const copies = [...track.children].slice(n);
  section.hidden = false;

  // Several messages can share the view; one step moves one message. Without more messages than fit, nothing moves.
  let stride = 1, looping = false;
  const measure = () => {
    copies.forEach(c => {c.hidden = false;});
    const slides = track.children;
    stride = slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left || track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    looping = n > Math.round((track.clientWidth + gap) / stride);
    copies.forEach(c => {c.hidden = !looping;});
    controls.hidden = !looping;
    rail.style.setProperty('--steps', n);
  };
  const position = () => track.scrollLeft / stride;
  const jump = step => track.scrollTo({left: step * stride, behavior: 'instant'});
  const glide = step => track.scrollTo({left: step * stride, behavior: reduced() ? 'instant' : 'smooth'});
  function next() {
    if (!looping) return;
    let at = Math.round(position());
    if (at >= n) {at -= n; jump(at);}
    glide(at + 1);
  }
  function prev() {
    if (!looping) return;
    let at = Math.round(position());
    if (at <= 0) {at = n; jump(at);}
    glide(at - 1);
  }
  // Once a move settles on a copy, swap to the matching original.
  let settleTimer = 0;
  const settle = () => {
    const at = Math.round(position());
    if (looping && at >= n) jump(at - n);
  };

  // Rail marker follows the swipe continuously, by message.
  let frame = 0;
  const update = () => {
    frame = 0;
    const at = ((position() % n) + n) % n;
    rail.style.setProperty('--rail', n > 1 ? Math.min(1, at / (n - 1)).toFixed(4) : 0);
  };
  track.addEventListener('scroll', () => {
    if (!frame) frame = requestAnimationFrame(update);
    clearTimeout(settleTimer); settleTimer = setTimeout(settle, 150);
  }, eventOptions({passive: true}));

  // Autoplay runs off the ring's CSS animation: it fills over the interval, and when it ends the row moves on.
  // Pausing the animation pauses the timer, so the ring always shows the real time left.
  let userPaused = false, inView = false, hovered = false, focused = false;
  const running = () => looping && !reduced() && !userPaused && inView && !hovered && !focused && !document.hidden;
  function sync() {
    const on = running();
    section.dataset.autoplay = on ? 'on' : 'off';
    // Screen readers hear each message only when it changes because of the visitor, not every few seconds.
    track.setAttribute('aria-live', on ? 'off' : 'polite');
    toggle.hidden = !looping || reduced();
    toggle.dataset.state = userPaused ? 'paused' : 'playing';
    toggle.setAttribute('aria-label', userPaused ? i18n["Play quotes"] : i18n["Pause quotes"]);
  }
  const restart = () => {ring.style.animation = 'none'; void ring.getBoundingClientRect(); ring.style.animation = '';};
  ring.addEventListener('animationend', () => {next(); restart();}, {signal:eventSignal});

  dom.getElementById('quotePrev').addEventListener('click', () => {prev(); restart();}, {signal:eventSignal});
  dom.getElementById('quoteNext').addEventListener('click', () => {next(); restart();}, {signal:eventSignal});
  toggle.addEventListener('click', () => {userPaused = !userPaused; sync();}, {signal:eventSignal});
  track.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault();
      (e.key === 'ArrowLeft' ? prev : next)();
      restart();
    }
  }, {signal:eventSignal});
  // A swipe or drag counts as the visitor taking over this message: the timer starts again from the beginning.
  track.addEventListener('pointerdown', restart, eventOptions({passive: true}));
  track.addEventListener('pointerenter', e => {if (e.pointerType === 'mouse') {hovered = true; sync();}}, {signal:eventSignal});
  track.addEventListener('pointerleave', () => {hovered = false; sync();}, {signal:eventSignal});
  track.addEventListener('focus', () => {focused = track.matches(':focus-visible'); sync();}, {signal:eventSignal});
  track.addEventListener('blur', () => {focused = false; sync();}, {signal:eventSignal});
  dom.addEventListener('visibilitychange', sync);
  motion.addEventListener?.('change', sync, {signal:eventSignal});
  if (typeof IntersectionObserver === 'function') {
    new IntersectionObserver(entries => {inView = entries.some(e => e.isIntersecting); sync();}, {threshold: .5}).observe(track);
  }

  new ResizeObserver(() => {
    const at = Math.round(position()) % n;
    measure();
    jump(looping ? at : 0);
    update(); sync();
  }).observe(track);
  measure();
  update(); sync();
})();

// ---- modern-buyer.js
// Buyer aids for the Modern and Original product pages: section shortcuts, cm/in switch, piece highlighting and the sticky buy bar.
(() => {
  const $ = id => dom.getElementById(id);
  const info = $('modernProductInfo'), bar = $('modernBuyBar');
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Shortcuts scroll without changing the product page hash (#modern-chess-set, #original-chess-set) the catalog listens to.
  info.querySelectorAll('.modern-jump a').forEach(link => link.addEventListener('click', event => {
    const section = dom.querySelector(link.getAttribute('href'));
    if(!section) return;
    event.preventDefault();
    section.scrollIntoView({behavior:reduced() ? 'instant' : 'smooth', block:'start'});
  }, {signal:eventSignal}));

  // Shipping and returns open by themselves on larger screens; on phones they start closed, to tap open.
  const phone = window.matchMedia('(max-width:700px)');
  const syncFacts = () => info.querySelectorAll('.facts-group').forEach(group => {group.open = !phone.matches;});
  phone.addEventListener('change', syncFacts, {signal:eventSignal});
  syncFacts();

  const unitButtons = info.querySelectorAll('[data-unit]');
  function setUnit(unit) {
    unitButtons.forEach(b => b.setAttribute('aria-pressed',String(b.dataset.unit === unit)));
    info.querySelectorAll('[data-cm][data-in]').forEach(el => {el.textContent = el.dataset[unit];});
    try {localStorage.setItem('masteek-unit',unit);} catch { /* Units still switch for this visit. */ }
  }
  unitButtons.forEach(b => b.addEventListener('click',() => setUnit(b.dataset.unit), {signal:eventSignal}));
  try {if(localStorage.getItem('masteek-unit') === 'in') setUnit('in');} catch { /* Default to centimetres. */ }

  // Hovering a piece in the lineup highlights it and dims the rest.
  const pieceParts = info.querySelectorAll('.modern-size-table [data-piece]');
  pieceParts.forEach(part => {
    const toggle = on => pieceParts.forEach(p => p.classList.toggle('is-highlighted',on && p.dataset.piece === part.dataset.piece));
    part.addEventListener('pointerenter',() => toggle(true), {signal:eventSignal});
    part.addEventListener('pointerleave',() => toggle(false), {signal:eventSignal});
  });

  let frame = 0;
  function updateBar() {
    frame = 0;
    const buy = $('productStoreLink').getBoundingClientRect(), final = $('modernFinalStoreLink').getBoundingClientRect();
    // Only while a product page is actually on screen: Home and Catalog hide a parent panel, not this section.
    const onProductPage = info.getClientRects().length > 0;
    // Shown once the buy box button has scrolled past and the closing button is still ahead. Not while that button is
    // still below the screen: the bar would then sit over the price and the add-on picker on phones.
    const show = onProductPage && buy.bottom < 0 && final.top > window.innerHeight;
    if(bar.hidden === show) bar.hidden = !show;
    dom.body.classList.toggle('has-buy-bar',show);
  }
  const schedule = () => {if(!frame) frame = requestAnimationFrame(updateBar);};
  // Re-checked on scroll, once per frame: the section shortcuts jump past the buy box without either button ever
  // crossing the viewport edge, so watching the buttons alone would miss those jumps.
  window.addEventListener('scroll',schedule, eventOptions({passive:true}));
  window.addEventListener('resize',schedule, {signal:eventSignal});
  // Re-check whenever the view changes: switching views toggles hidden on these panels.
  const views = new MutationObserver(schedule);
  [info, $('shopPanel'), $('collectionDetail')].forEach(el => views.observe(el,{attributes:true,attributeFilter:['hidden']}));
  schedule();

  // Sections rise in once on first view. Without IntersectionObserver or with reduced motion they simply stay visible.
  if(typeof IntersectionObserver === 'function' && !reduced()) {
    const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
      if(!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      reveal.unobserve(entry.target);
    }),{rootMargin:'0px 0px -10% 0px',threshold:.08});
    info.querySelectorAll('.pdp-reveal').forEach(section => reveal.observe(section));
    info.classList.add('js-reveal');
  }
})();
      // The route gate set before the scripts ran has done its job once the first view is applied.
      root.classList.remove('route-away');
    }
    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      this.eventController?.abort();
      this.observers?.forEach(observer => observer.disconnect());
      this.timers?.forEach(id => window.clearTimeout(id));
      this.frames?.forEach(id => window.cancelAnimationFrame(id));
      this.catalogMounted = false;
    }
  }
  customElements.define('masteek-native-catalog', MasteekNativeCatalog);
})();
